import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Activity,
  Gauge,
  Newspaper,
  FileCode,
  Home,
  BarChart,
  Target, 
  Settings,
  DollarSign,
  LineChart,
  BrainCog,
  Users,
  LayoutGrid,
  GitCompareArrows,
  LogOut,
  ChevronLeft,
  Menu,
  ChevronDown,
  ChevronRight,
  Building,
  Plus,
  RefreshCw,
  Globe,
  Package,
  Filter,
  Bot,
  Table,
  LayoutDashboard,
  BarChart3,
  CreditCard,
  HelpCircle,
  Megaphone,
  Briefcase,
  Trello,
  Share2,
  BarChart2,
  Clock,
  Building2,
  UserPlus,
  Car,
  CalendarDays,
  FileText,
  Search,
  MapPin,
  Database,
  TrendingUp,
  History,
  ClipboardList,
  ClipboardCheck,
  MonitorPlay,
  Layers,
  Receipt,
  Instagram,
  Linkedin,
  Inbox,
  Mail,
  Aperture,
  Frame,
  ShieldCheck,
} from "lucide-react";
import { useAuth } from '../../context/AuthContext';
import { hasAiVisibility, hasPersonas, hasTodo } from '../../config/aiVisibilityBrands';
import { Disclosure } from '@headlessui/react';
import { api as lensApi } from '../../pages/custom-reports/lib';


// custom-report'un açık olduğu Yataş grubu markaları. Rapor ve Veri Girişi
// menüleri AYNI listeyi kullanır; ayrıca backend denetimindeki AUDIT_BRAND_IDS
// ile de aynı kalmalı (reportAuditService.js).
// Kampanya Söylemleri sözlüğü kurulu markalar (backend theme_catalog dolu)
const CAMPAIGN_THEME_BRANDS = [
  '44e35dfe-0186-495d-a0cc-db5e7e459ab7', // Yataş Bedding
  '7fc8e68d-f2ba-4101-95f7-acece386ab8f', // puffy
  'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e', // EnzaHome
];
const YATAS_REPORT_BRANDS = [
  '44e35dfe-0186-495d-a0cc-db5e7e459ab7', // Yataş Bedding
  'dfcf54dd-b00d-434a-be1e-27b6484848eb', // Divanev
  '7fc8e68d-f2ba-4101-95f7-acece386ab8f', // puffy
  'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e', // EnzaHome
];
// Yataş menü sadeleştirmesi (Esra, 12 Eki 2026): Overview kalkar, sıra Pano → Bülten → AI Visibility → Raporlar.
// Overview'u yalnız bizim hesaplar görmeye devam eder.
const YATAS_OVERVIEW_EMAILS = ['efe@heyglowy.com', 'efe@glowytics.com'];
const YATAS_MENU_FIRST = ['AI Visibility', 'Raporlar'];

// restrictedEmails girdisi '@alan.com' ile başlıyorsa o alan adındaki herkes görür.
const epostaIzinli = (liste, eposta) => {
  if (!liste) return true;
  const e = String(eposta || '').toLowerCase();
  return liste.some((x) => (x.startsWith('@') ? e.endsWith(x) : x === e));
};

const navItems = [

  {
    label: "Google Ads",
    href: "/ads-platforms/google-ads",
    marketerVisible: true,
    subItems: [
      { label: "Overview", href: "/ads-platforms/google-ads" },
      { label: "Search", href: "/ads-platforms/google-ads/search" },
      { label: "Display", href: "/ads-platforms/google-ads/display" },
      { label: "Demand Gen", href: "/ads-platforms/google-ads/demand-gen" },
      { label: "GDN Creatives", href: "/ads-platforms/google-ads/gdn-creatives", marketerVisible: true },
      { label: "Shopping", href: "/ads-platforms/google-ads/shopping" },
      { label: "Performance Max", href: "/ads-platforms/google-ads/pmax" },
      { label: "PMax Asset Performance", href: "/ads-platforms/google-ads/pmax-assets", marketerVisible: true },
      { label: "Dynamic Search", href: "/ads-platforms/google-ads/dsa" },
      { label: "Video", href: "/ads-platforms/google-ads/video" },
      { label: "App", href: "/ads-platforms/google-ads/app" },
      { label: "Audience Insights", href: "/ads-platforms/google-ads/audience-insights", marketerVisible: true },
      // Arama görünürlüğü / ses payı (canlı). Şimdilik sadece High5 — ASICS sprinti
      // için açıldı; sayfa jenerik, başka markaya açmak allowBrandIds'e eklemek.
      { label: "Visibility & Share of Voice (Live)", href: "/ads-platforms/google-ads/visibility", marketerVisible: true, brandingVisible: true, allowBrandIds: ['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8'] },
      // Yukarıdaki sayfanın Kampanya × dönem gösterim payı tablosu, tek başına.
      // Tüm markalara açık: veri /api/ads-visibility/matrix'ten marka bağlamıyla gelir.
      // (Sayfa içindeki haftalık marka kampanyası rafı yalnız High5'te görünür.)
      { label: "Impression Share by Campaign", href: "/ads-platforms/google-ads/impression-share", marketerVisible: true, brandingVisible: true },
      // Marka aranma hacmi ↔ marka arama kampanyalarından aldığımız pay. High5'e özel.
      { label: "Brand Search Coverage", href: "/high5/marka-kapsama", marketerVisible: true, brandingVisible: true, allowBrandIds: ['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8'] },
      // Marka arama kampanyalarında rakip rafı (canlı). Yüzdeler API'de kapalı, gün oranı vekil.
      { label: "Auction Insights", href: "/high5/acik-artirma", marketerVisible: true, brandingVisible: true, allowBrandIds: ['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8'] },
      { label: "Conversion & ROAS Audit (Live)", href: "/blackspade/donusum-denetimi", marketerVisible: true, allowBrandIds: ['3ec08d8c-e9b9-4c83-962f-0871d32edb2c'] },
      { label: "Search Campaign Wizard", href: "/labs/search-campaign-wizard", ownerAdminOnly: true },
    ]
  },
  {
    label: "Meta Ads",
    href: "/ads-platforms/meta-overview",
    marketerVisible: true,
    subItems: [
      { label: "Overview", href: "/ads-platforms/meta-overview" },
      { label: "Campaign Type", href: "/ads-platforms/meta-ads/campaign-type" },
      { label: "Creative Performance", href: "/ads-platforms/meta-ads/creative-performance", marketerVisible: true },
      { label: "Catalog Product Spend", href: "/ads-platforms/meta-ads/product-spend", marketerVisible: true, yatasMarketerHidden: true },
      { label: "A/B Test (Live)", href: "/ads-platforms/meta-ads/ab-compare", marketerVisible: true, yatasMarketerHidden: true },
      { label: "Remarketing vs New User (Live)", href: "/ads-platforms/meta-ads/rm-vs-newuser", marketerVisible: true, yatasMarketerHidden: true },
      { label: "Today's Impressions (Live)", href: "/ads-platforms/meta-ads/today-impressions", marketerVisible: true },
      { label: "Catalog Product Sets", href: "/meta-catalog/products-sets" },
      { label: "Meta Audiences", href: "/meta/meta-audiences" },
      // Glowy AI kitle önerileri: Meta'ya yazabildiği için şimdilik iç ekip; backend de kilitli.
      { label: "Audience Suggestions (Glowy AI)", href: "/meta/kitle-onerileri", visibleFor: (_b, email) => epostaIzinli(['@glowytics.com', '@heyglowy.com'], email) },
      { label: "Meta Audience Insights", href: "/meta/meta-audience-insights", marketerVisible: true },
      { label: "Media Library", href: "/labs/meta-media-library", ownerAdminOnly: true },
      {
        label: "Engagement Monitor (Live)",
        href: "/ads-platforms/meta-ads/engagement-monitor",
        allowBrandIds: [
          '44e35dfe-0186-495d-a0cc-db5e7e459ab7', // Yataş Bedding
          'dfcf54dd-b00d-434a-be1e-27b6484848eb', // Divanev
          '7fc8e68d-f2ba-4101-95f7-acece386ab8f', // Puffy
          'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e', // EnzaHome
        ],
      },
    ]
  },
  {
    label: "TikTok Ads",
    href: "/ads-platforms/tiktok-ads/campaign-type",
    icon: "TikTokIcon",
    iconSrc: "/tik-tokiconss.png",
    marketerVisible: true,
    subItems: [
      { label: "Campaign Type", href: "/ads-platforms/tiktok-ads/campaign-type", marketerVisible: true },
      { label: "Creative Performance", href: "/ads-platforms/tiktok-ads/creative-performance", marketerVisible: true },
    ]
  },
  {
    label: "Criteo",
    href: "/ads-platforms/criteo-overview",
    icon: "CriteoIcon",
    iconSrc: "/CRcriteopng.png",
  },
  {
    label: "RTB House",
    href: "/market-insights/rtbhouse-connect",
    icon: "RtbHouseIcon",
    iconSrc: "/RTBhouseiconPNG.png",
  },
  {
    label: "Pinterest",
    href: "/pinterest-dashboard",
    icon: "PinterestIcon",
    iconSrc: "/pinterestlogopng.png",
    marketerVisible: true,
    subItems: [
      { label: "Overview", href: "/pinterest-dashboard" },
      { label: "Creative Performance", href: "/ads-platforms/pinterest/creative-performance", marketerVisible: true },
    ],
  },
  {
    label: "Google Analytics",
    href: "/analytics",
    icon: "AnalyticsIcon",
    iconSrc: "/GA4logoicon.svg",
    marketerVisible: true,
    subItems: [
      { label: "GA4 Overview", href: "/analytics/ga4-overview" },
      { label: "GA4 Custom Dimensions", href: "/analytics/ga4-custom-dimensions", allowUserIds: ['95bf7597-bb83-4f50-9bdb-8678a86e1084'] },
      { label: "GA4 Audience", href: "/analytics/ga4-audience", marketerVisible: true },
      { label: "Page → Source/Medium (Live)", href: "/analytics/page-source-medium-live", allowBrandIds: ['526a6404-f685-44cd-b57f-27d692845b82'] },
      { label: "New vs Returning Revenue", href: "/analytics/new-vs-returning-revenue" },
      { label: "Session Engagement", href: "/analytics/session-engagement" },
      { label: "Daily Funnel", href: "/analytics/daily-funnel", marketerVisible: true },
      { label: "Hourly Order Analysis", href: "/analytics/hourly-order-analysis", marketerVisible: true },
      { label: "Weekday Order Analysis", href: "/analytics/weekday-order-analysis", marketerVisible: true },
      { label: "Hedef vs Gerçekleşen (Günlük)", href: "/high5/hedef-takip", marketerVisible: true, allowBrandIds: ['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8'] },
      { label: "MTD Ciro Hedefi", href: "/high5/mtd-hedef", marketerVisible: true, allowBrandIds: ['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8'] },
      { label: "Haftalık KPI (Paid / UnPaid)", href: "/high5/haftalik-kpi", marketerVisible: true, allowBrandIds: ['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8'] },
      { label: "Customer LTV & Repeat Purchase", href: "/high5/ltv", marketerVisible: true, allowBrandIds: ['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8'] },
      { label: "Product Size Distribution", href: "/high5/size-coverage", marketerVisible: true, allowBrandIds: ['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8'] },
      { label: "GA4 360 Business Case", href: "/koton/ga4-360", marketerVisible: true, allowBrandIds: ['062be473-3b2b-4bad-a2e3-a31995e02d57'] },
      { label: "Traffic Acquisition", href: "/analytics/source-medium-monthly" },
      { label: "GA + Adjust (Combined)", href: "/analytics/combined-traffic-sources" },
      { label: "Product Performance", href: "/analytics/product-performance", marketerVisible: true },
      { label: "Funnel Analysis", href: "/analytics/funnel" },
      { label: "On‑site search", href: "/analytics/internal-search-terms", marketerVisible: true },
      { label: "BigQuery Analytics", href: "/analytics/bq-dashboard" },
      { label: "Daily Traffic Sources (BQ)", href: "/analytics/bq-traffic-daily" },
      { label: "Product Sales (BQ)", href: "/analytics/bq-item-sales" }
    ],
  },
  {
    label: "Adjust",
    href: "/adjust",
    icon: "AdjustIcon",
    subItems: [
      { label: "Overview", href: "/adjust/overview" },
      { label: "Traffic Acquisition", href: "/adjust/traffic-acquisition" },
      { label: "Source & Medium (Monthly)", href: "/analytics/adjust-source-medium-monthly" }
    ]
  },
  {
    label: "Growth Intelligence",
    href: "/growth-intelligence",
    icon: "GrowthIntelligenceIcon",
    marketerVisible: true,
    subItems: [
      { label: "Product Portfolio Analysis", href: "/analytics/product-portfolio-analysis" },
      { label: "Price Elasticity of Demand", href: "/analytics/price-elasticity-of-demand" },
      { label: "Revenue Forecasting", href: "/analytics/revenue-forecasting" },
      { label: "Campaign Periods", href: "/analytics/period-analysis", icon: "calendar", marketerVisible: false },
    ],
  },
  {
    label: "Market Insights",
    href: "/market-insights",
    icon: "MarketInsightsIcon",
    marketerVisible: true,
    brandingVisible: true,
    subItems: [
      { label: "Facebook Ads Library", href: "/market-insights/facebook-ads-library", brandingVisible: true },
      { label: "Google Ads Transparency", href: "/market-insights/google-ads-transparency", brandingVisible: true },
        { label: "Search Volume", href: "/market-insights/search-volume", brandingVisible: true },
        { label: "Search Volume Matrix", href: "/market-insights/search-volume-matrix", brandingVisible: true, allowBrandIds: ['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8'] },
        { label: "Search Volume Radar", href: "/market-insights/high5-search-research", brandingVisible: true },
        { label: "Keyword Discover", href: "/market-insights/keyword-discover", brandingVisible: true },
      { label: "Google Trends", href: "/market-insights/google-trends", brandingVisible: true },
      { label: "YouTube Trends", href: "/market-insights/youtube-trends", brandingVisible: true },
      { label: "Category Seasonality", href: "/market-insights/category-seasonality", brandingVisible: true },
      { label: "Merchant Insights", href: "/market-insights/merchantinsights", brandingVisible: true },
      { label: "Marketing Holiday Planner", href: "/market-insights/campaign-calendar", brandingVisible: true },
      { label: "Location & Review Explorer", href: "/market-insights/place-reviews", brandingVisible: true, visibleFor: (bid) => !YATAS_REPORT_BRANDS.includes(bid) },
      // 29 Eki 2026: High5 menüsü yeni satıcı bazlı sayfaya gider; eski /high5/price-comparison URL ile açık kalır
      { label: "Price Comparison", href: "/high5/price-by-seller", marketerVisible: true, brandingVisible: true, allowBrandIds: ['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8'] },
      { label: "Price Comparison", href: "/skechers/price-comparison", marketerVisible: true, brandingVisible: true, allowBrandIds: ['fbef3c8c-dbb1-4cf0-bbe7-abacb1a76c74'] },
      { label: "Price Comparison", href: "/kixz/price-comparison", marketerVisible: true, brandingVisible: true, allowBrandIds: ['6e38ac10-35a4-49e3-9f71-d5d08f8ad20c'] },
      { label: "Price Tracking", href: "/propia/price-tracking", marketerVisible: true, brandingVisible: true, allowBrandIds: ['e1c18e45-15db-4200-8fca-b150d15ac7aa'] },
      { label: "Price vs Google Benchmark", href: "/skechers/price-vs-benchmark", marketerVisible: true, brandingVisible: true, allowBrandIds: ['fbef3c8c-dbb1-4cf0-bbe7-abacb1a76c74'] },
      { label: "Price Comparison", href: "/velorent/price-comparison", marketerVisible: true, brandingVisible: true, allowBrandIds: ['9cab92ad-1422-4684-9d57-2ef1464338ec'] }
    ]
  },
  {
    label: "Social Intelligence",
    href: "/social-intelligence",
    icon: "SocialIntelligenceIcon",
    marketerVisible: true,
    brandingVisible: true,
    subItems: [
      { label: "YouTube Radar", href: "/market-insights/youtube-radar", brandingVisible: true },
      { label: "Instagram Radar", href: "/market-insights/instagram-radar", brandingVisible: true },
      { label: "Instagram Comments", href: "/market-insights/instagram-comments", brandingVisible: true },
      { label: "TikTok Radar", href: "/market-insights/tiktok-radar", brandingVisible: true },
      { label: "App Radar", href: "/market-insights/app-radar", brandingVisible: true },
      { label: "MultiPay Review Analysis", href: "/market-insights/multipay-yorum-analizi", brandingVisible: true, allowBrandIds: ['7f97784c-d406-4400-830b-8d13a7c21d5f'] }
    ]
  },
  {
    label: "Commerce Center",
    href: "/commerce-center",
    icon: "CommerceIcon",
    subItems: [
      { label: "Google Merchant Center", href: "/merchant-center/performance" },
      { label: "Price Benchmark", href: "/merchant-center/price-benchmark", icon: "/google-merchant-centerpngg.svg" },
      { label: "Merchant Center Inventory", href: "/merchant-center/inventory" },
      { label: "Variant Performance", href: "/merchant-center/variant-performance" },
      { label: "Custom Labels & BCG", href: "/merchant-center/custom-labels" },
      { label: "Discount Tracking", href: "/merchant-center/discount-tracking" },
      { label: "XML Feed Analyzer", href: "/xml-feed-analyzer" },
      { label: "Feed Diff (Source ↔ Ads)", href: "/high5/feed-farki", marketerVisible: true, allowBrandIds: ['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8'] },
      { label: "Sold Products — Size Status", href: "/high5/satan-beden", marketerVisible: true, allowBrandIds: ['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8'] },
      { label: "Product Sales (Weekly / Monthly)", href: "/high5/urun-satislari", marketerVisible: true, allowBrandIds: ['b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8'] }
    ]
  },
  {
    label: "Search Console",
    href: "/search-console",
    icon: "SearchConsoleIcon",
    subItems: [
      { label: "Overview", href: "/search-console/overview" },
      { label: "Monthly Queries", href: "/search-console/monthly-queries" },
      { label: "Blog SEO", href: "/search-console/blog-seo" }
    ]
  },

  {
    label: "Business Profile",
    href: "/gbp/locations",
    icon: MapPin,
    marketerVisible: true,
    subItems: [
      { label: "Locations", href: "/gbp/locations", marketerVisible: true },
      // Kaydet/Başarsoft aylık lokasyon raporunun panel karşılığı + reklamlı kutu (29 Eyl 2026).
      // 30 Eyl 2026: Yataş Reports altından buraya taşındı, sadece Divanev.
      { label: "Location Summary", href: "/r/divanev-lokasyon", marketerVisible: true, allowBrandIds: ['dfcf54dd-b00d-434a-be1e-27b6484848eb'] },
      // GBP → reklamlı lokasyon aksiyonları → lokal bütçe (7 Eki 2026, Yataş toplantısı). Yataş 4'lüsü.
      { label: "Local Performance", href: "/gbp/lokal", marketerVisible: true, allowBrandIds: ['44e35dfe-0186-495d-a0cc-db5e7e459ab7', 'dfcf54dd-b00d-434a-be1e-27b6484848eb', '7fc8e68d-f2ba-4101-95f7-acece386ab8f', 'ccb2364b-e4e1-4f7f-944a-44cc9a839c6e'] },
      // Yataş'ta Market Insights yerine burada (Esra, 12 Eki 2026)
      { label: "Location & Review Explorer", href: "/market-insights/place-reviews", marketerVisible: true, allowBrandIds: YATAS_REPORT_BRANDS },
    ]
  },

  {
    label: "GlowyAI",
    href: "/glowyai-marketing-assistant",
    icon: "GlowyAIIcon",
    marketerVisible: true,
    subItems: null
  },

  {
    // GlowyAI sağlık kontrolü: Google Ads + Meta + GA4, salt okuma. Efe + Yataş ekibi (26 Eki); backend de kilitli.
    label: "Account Health",
    href: "/glowyai/health-check",
    icon: ShieldCheck,
    subItems: null,
    restrictedEmails: ['efe@heyglowy.com', 'efe@glowytics.com', '@yatas.com.tr', '@digitalhouse.com.tr'],
  },

  {
    label: "Hourly Performance",
    href: "/hourly-performance",
    icon: Clock,
    subItems: null,
    restrictedBrands: ['58aab54e-8d8c-499c-b706-86ec9435adaf'] // Sadece bu brand ID'de göster
  },

  {
    label: "Task Board",
    href: "/taskboard",
    icon: "TrelloSvgIcon",
    subItems: null,
    hideForDemo: true
  },

  // Yataş grubu menüsü İKİYE ayrıldı (3 Eyl 2026, Efe): sekiz maddenin bir kısmı
  // okunan RAPOR, bir kısmı elle VERİ GİRİŞİ sayfası — aynı listede durunca
  // hangisine girip veri yazacağı karışıyordu.
  // Giriş sayfaları: kaydetme akışı olanlar (Target vs Actual → KPI hedefi,
  // report-4 → bütçe/gelir planı, report-6 → medya satın alma dönüştürücü).
  // İkisinin de kapsamı AYNI dört marka; biri değişirse diğeri de değişmeli.
  {
    label: "Raporlar",
    href: "/custom-report",
    icon: FileText,
    marketerVisible: true,
    restrictedBrands: YATAS_REPORT_BRANDS,
    // Sekiz madde TEK menüde ama iki gruba ayrılmış (3 Eyl 2026, Efe): bir kısmı
    // okunan RAPOR, bir kısmı elle VERİ GİRİŞİ sayfası. Ayrım kaydetme akışına
    // göre: Target vs Actual (KPI hedefi), report-4 (bütçe/gelir planı) ve
    // report-6 (medya satın alma dönüştürücü) veri yazar, diğerleri sadece okur.
    // `groupHeader: true` satırları link değil, başlık olarak çizilir.
    subItems: [
      { label: "Raporlar", groupHeader: true, marketerVisible: true },
      { label: "Dinamik Takip", href: "/yatas/takip", marketerVisible: true },
      // Aylık Bülten üst menüde (Pano'nun altında); rapor adları Esra'nın listesi (12 Eki 2026)
      { label: "Kampanya Raporu", href: "/custom-report/report-1" },
      { label: "Branding Raporu", href: "/custom-report/report-2" },
      { label: "Performans Raporu", href: "/custom-report/report-3" },
      { label: "Kanal Kırılım Raporu (All)", href: "/custom-report/report-5" },
      { label: "Kanal Kırılım Raporu (Brand)", href: "/custom-report/report-7" },
      { label: "Kampanya Kodları", href: "/yatas/kampanya-kodlari", marketerVisible: true },
      // Planlama MARKETER'a kapalı (28 Eyl 2026, Efe) — route'ta da denyRoles var.
      { label: "Planlama", groupHeader: true, marketerVisible: false },
      { label: "Medya Planlama & Asistan", href: "/yatas/planlama", marketerVisible: false },
      { label: "Davranış Segmentasyonu", href: "/yatas/davranis-segmentasyonu", marketerVisible: true },
      { label: "Davranış Haritası", href: "/yatas/davranis-haritasi", marketerVisible: true },
      { label: "Veri Girişi", groupHeader: true, marketerVisible: true },
      { label: "Target vs Actual", href: "/labs/kpi-targets", marketerVisible: true },
      { label: "Budget & Revenue Target Plan", href: "/custom-report/report-4", marketerVisible: false },
      { label: "Media Buying Converter", href: "/custom-report/report-6", marketerVisible: false },
    ]
  },

  // Yapay zeka asistanları (ChatGPT/Gemini) hangi markayı hangi ihtiyaçta öneriyor.
  // Proje seçimi backend'de (ai_visibility.projects.owner_brand_ids): dört Yataş markası
  // AYNI Yataş Grup verisini, HUPALUPA Eğlence ve Multinet (22 Eyl) kendi projelerini görür.
  // 3 Eki 2026: HER markada görünür; projesi olmayan marka tanıtım sayfasını görür (AiVisibilityLanding).
  // Yeni marka açmak = projeyi kurmak + config/aiVisibilityBrands.js'e eklemek.
  {
    label: "AI Visibility",
    href: "/ai-visibility",
    icon: Bot,
    marketerVisible: true,
    brandingVisible: true,
    subItems: [
      { label: "Overview", href: "/ai-visibility", marketerVisible: true, brandingVisible: true },
      // Hangi site kaynak gösterildiğinde hangi marka önerildi (30 Eyl 2026) — yalnız projesi olanlar
      { label: "Kaynak × Marka", href: "/ai-visibility/kaynaklar", marketerVisible: true, brandingVisible: true, visibleFor: hasAiVisibility },
      // SEO/içerik yapılacaklar listesi (2 Kas 2026) — yalnız Yataş Grup markaları
      { label: "Yapılacaklar", href: "/ai-visibility/yapilacaklar", marketerVisible: true, brandingVisible: true, visibleFor: hasTodo },
      // Derma persona konuşmaları (3 Eki 2026) — yalnız glowy markası + Efe
      { label: "Personalar", href: "/ai-visibility/personalar", marketerVisible: true, brandingVisible: true, visibleFor: hasPersonas },
    ],
  },

  // Genel harcama faturası — her markada çalışır, oran varsaymaz.
  // Yataş grubuna özel `/faturalama` sayfası BİLEREK menüde değil (Efe, Ağu 2026).
  {
    label: "Spend Invoice",
    href: "/harcama-faturasi",
    icon: Receipt,
    subItems: null,
  },

  {
    label: "Sixt Store/Branch Performance",
    href: "/sixt-store-branch-performance",
    icon: Building2,
    subItems: null,
    restrictedBrands: ['482af302-f9a8-4d10-b8dc-0be9cf91f521'] // Sixt brand ID'si
  },
  {
    label: "Sixt Location Pricing",
    href: "/sixt-location-pricing",
    icon: DollarSign,
    subItems: null,
    restrictedBrands: ['482af302-f9a8-4d10-b8dc-0be9cf91f521'] // Sixt brand ID'si
  },
  {
    label: "Vehicle Performance",
    href: "/sixt-vehicle-performance",
    icon: Car,
    subItems: null,
    restrictedBrands: ['482af302-f9a8-4d10-b8dc-0be9cf91f521'] // Sixt brand ID'si
  },
  {
    label: "Campaign Report",
    href: "/reports/campaign-report",
    icon: FileText,
    subItems: null,
    restrictedBrands: ['9e1cb4b4-6a46-44ec-85b5-652665a4bd2b']
  },
  {
    label: "Salomon · Eylül",
    href: "/reports/salomon-eylul",
    icon: FileText,
    subItems: null,
    restrictedBrands: ['9e1cb4b4-6a46-44ec-85b5-652665a4bd2b']
  },
  {
    label: "adidas · FW26",
    href: "/reports/adidas-fw26",
    icon: FileText,
    subItems: null,
    restrictedBrands: ['9e1cb4b4-6a46-44ec-85b5-652665a4bd2b']
  },
  {
    // Wunder marka planları takibi (ASICS/adidas/Salomon), iç notlar içerir: yalnız Efe.
    label: "Marka Planları",
    href: "/wunder/planlar",
    icon: FileText,
    subItems: null,
    restrictedEmails: ['efe@heyglowy.com', 'efe@glowytics.com'],
  },
  {
    // Kampanya Söylemleri: reklam metni söylemlerine göre harcama raporu. Söylem sözlüğü kurulu markalarda
    // (Yataş grubu) markanın kullanıcıları görür; MARKETER (marketerVisible yok) ve FINANCE/GBP görmez, route'ta
    // denyRoles, backend'de rol kontrolü var. Sözlüğü düzenleme backend'de yalnız Efe.
    label: "Kampanya Söylemleri",
    href: "/kampanya-soylemleri",
    icon: FileText,
    subItems: null,
    restrictedBrands: CAMPAIGN_THEME_BRANDS,
  },
  {
    label: "ASICS · Eylül",
    href: "/reports/asics-eylul",
    icon: FileText,
    subItems: null,
    restrictedBrands: ['9e1cb4b4-6a46-44ec-85b5-652665a4bd2b']
  },
  {
    label: "Product Catalog",
    href: "/grace/catalog",
    icon: Package,
    marketerVisible: true,
    subItems: null,
    restrictedBrands: ['29072fbc-294f-49f1-bb0b-6868f7e54d41'] // Grace Brands
  },
  {
    label: "Product Catalog",
    href: "/paulmark/catalog",
    icon: Package,
    marketerVisible: true,
    subItems: null,
    restrictedBrands: ['8591f281-715d-4a80-83cf-59bfb59f6ef3'] // Paulmark
  },
  {
    label: "Weekly Report",
    href: "/weekly-report",
    icon: CalendarDays,
    subItems: null,
    restrictedBrands: [
      'c7778265-8ac6-4697-ae89-2f4da315d0ac', // Yenilio
      '526a6404-f685-44cd-b57f-27d692845b82', // Gürgençler
    ],
    restrictedEmails: ['efe@heyglowy.com'],
  },
  {
    // Marka Talepleri: müşteri maillerinden çıkarılan bekleyen işler. Sadece Efe; backend de kilitli.
    label: "Marka Talepleri",
    href: "/talepler",
    icon: Inbox,
    subItems: null,
    restrictedEmails: ['efe@heyglowy.com'],
  },
  {
    // LinkedIn Stüdyosu: konu fikri, gönderi metni, Gemini görseli. İç ekip; backend de kilitli.
    label: "LinkedIn Stüdyosu",
    href: "/linkedin-studyo",
    icon: Linkedin,
    subItems: null,
    restrictedEmails: ['@glowytics.com', '@heyglowy.com'],
  },
  {
    // Kullanıcı Takibi: panel kullanıcılarının giriş + sayfa hareketleri. Sadece Efe; backend de kilitli.
    label: "Kullanıcı Takibi",
    href: "/kullanici-takip",
    icon: Activity,
    subItems: null,
    restrictedEmails: ['efe@heyglowy.com'],
  },
  {
    // Yeni Kullanıcılar / Yeni Markalar: son bakıştan sonra gelen kayıtlar işaretli. Sadece Efe; backend de kilitli.
    label: "Yeni Kullanıcılar",
    href: "/yeni-kullanicilar",
    icon: UserPlus,
    subItems: null,
    restrictedEmails: ['efe@heyglowy.com'],
  },
  {
    label: "Yeni Markalar",
    href: "/yeni-markalar",
    icon: Building2,
    subItems: null,
    restrictedEmails: ['efe@heyglowy.com'],
  },
  {
    // Glowytics'in kendi Instagram hesabı — marka bağımsız iç araç.
    // restrictedBrands YOK: hangi marka seçili olursa olsun görünmeli.
    label: "Instagram Studio",
    href: "/social/instagram",
    icon: Instagram,
    subItems: null,
    restrictedEmails: ['efe@heyglowy.com'],
  },
  {
    // Merchant Center ürünlerinden çerçeveli/sahneli ürün kataloğu üretir.
    // Marka bağımsız: MC bağlantısı olan her markada çalışır, olmayanda boş durum gösterir.
    // Herkese açmak için: aşağıdaki restrictedEmails satırını sil.
    label: "Glowy Studio",
    afterOnsite: true, // OnSite grubunun altında çizilir
    href: "/glowy-studio",
    icon: Layers,
    // 🔑 Sayfa başlığındaki 3B ikonun AYNISI (tek kaynak: backend public).
    // `iconSrc` her iki dalda da (aktif/pasif) `icon`'un önüne geçiyor;
    // `icon: Layers` yalnız görsel yüklenemezse diye duruyor.
    // 🔴 `?v=` damgası ŞART — dosya adı sabit, /pixel uzun önbellekliyor.
    iconSrc: "https://api.glowytics.com/pixel/glowy-studio/icon-cerceve.png?v=2",
    subItems: null,
    restrictedEmails: ['efe@heyglowy.com', 'omer@dpedijital.com'],
  },
  {
    // Çerçeve Atölyesi: ekip Claude'la marka çerçevesi üretir, galeriyi müşteriye atar,
    // feed bağlama talebi açar. Marka bağımsız iç araç; backend de alan adıyla kilitli.
    label: "Çerçeve Atölyesi",
    afterOnsite: true,
    href: "/cerceve-atolyesi",
    icon: Frame,
    subItems: null,
    restrictedEmails: ['@heyglowy.com', 'efe@glowytics.com'],
  },
  {
    // Glowy Lens (eski adıyla Custom Reports): kullanıcının kendi kurduğu widget/grafik/pivot
    // raporları, AI ile tariften kurma dahil. Route /custom-reports olarak kaldı.
    label: "Glowy Lens",
    afterOnsite: true, // OnSite grubunun altında çizilir
    href: "/custom-reports",
    icon: Aperture,
    subItems: null,
    restrictedEmails: ['efe@heyglowy.com'],
  },
  {
    // Glowy Mail: e-posta pazarlama platformu (SES). Marka bağımsız; şimdilik yalnız gönderim domain'leri.
    label: "Glowy Mail",
    afterOnsite: true, // OnSite grubunun altında çizilir
    href: "/email",
    icon: Mail,
    subItems: null,
    restrictedEmails: ['efe@heyglowy.com'],
  },
  {
    // Müşteri sitesindeki form doldurumları. Sadece Lead Inbox sitesi tanımlı
    // markalarda anlamlı; tanımsız markada sayfa kendi boş durumunu gösteriyor.
    label: "Lead Kutusu",
    href: "/leadler",
    icon: Inbox,
    subItems: null,
    restrictedBrands: ['d350d46e-fa7e-4aa0-98d6-317aca15c607'], // Kixx
    restrictedEmails: ['efe@heyglowy.com'],
  },
  {
    // Glowy OnSite çatısı altındaki Widgets: canlı siteyi iframe'de açıp on-site widget'ları
    // (duyuru/popup/öneri/sepet) kurma. Şimdilik sadece hosgelsin (backend: pixel.js EDITOR_BRAND_IDS).
    label: "Widgets",
    href: "/cro/widgets",
    icon: LayoutGrid,
    subItems: null,
    onsite: true, // listenin en altında ayrı "Glowy OnSite · Beta" grubunda çizilir
    restrictedBrands: ['8a07ce35-0fb3-4019-b0b2-60617b3c1d29'], // hosgelsin
    restrictedEmails: ['efe@heyglowy.com'],
  },
  {
    // Birinci taraf, tekilleştirilmiş sipariş kaynağı takibi (backend: routes/attribution.js). Şimdilik sadece hosgelsin.
    label: "Kaynak Takibi",
    href: "/cro/kaynak-takibi",
    icon: GitCompareArrows,
    subItems: null,
    onsite: true,
    restrictedBrands: ['8a07ce35-0fb3-4019-b0b2-60617b3c1d29'], // hosgelsin
    restrictedEmails: ['efe@heyglowy.com'],
  },
  {
    // Kaynak takibinin GTM kurulum rehberi: seçili markaya göre etiketler + anahtar. Her markada görünür, yalnız iç kullanım.
    label: "GTM Setup",
    href: "/cro/kaynak-takibi/kurulum",
    icon: GitCompareArrows,
    subItems: null,
    onsite: true,
    restrictedEmails: ['efe@heyglowy.com'],
  },
  {
    // Site içi AI sohbet asistanı yönetimi (görünüm, bilgi kaynakları, konuşmalar, lead'ler).
    // Şimdilik sadece hosgelsin; backend'de de e-posta + marka kilidi var.
    label: "Glowy Desk",
    href: "/cro/asistan",
    icon: Bot,
    subItems: null,
    onsite: true,
    restrictedBrands: ['8a07ce35-0fb3-4019-b0b2-60617b3c1d29'], // hosgelsin
    restrictedEmails: ['efe@heyglowy.com'],
  },
  {
    label: "Meeting Notes",
    href: "/r/europcar-toplanti-21-07-2026",
    icon: ClipboardList,
    subItems: null,
    marketerVisible: true,
    brandingVisible: true,
    restrictedBrands: ['13b58e06-8266-4a5b-8113-2de43aa686e1'], // Europcar
  },
  {
    label: "Source Report",
    href: "/r/europcar-kaynak",
    icon: BarChart3,
    subItems: null,
    marketerVisible: true,
    brandingVisible: true,
    restrictedBrands: ['13b58e06-8266-4a5b-8113-2de43aa686e1'], // Europcar
  },
  {
    label: "Coral Report",
    href: "/r/canon-coral",
    icon: BarChart3,
    subItems: null,
    marketerVisible: true,
    brandingVisible: true,
    restrictedBrands: ['3987361f-4006-4819-bd83-f78b5a2155ec'], // Canon
  },
  {
    label: "GA4 Measurement Dashboard",
    href: "/r/europcar-ga4",
    icon: Activity,
    subItems: null,
    marketerVisible: true,
    brandingVisible: true,
    restrictedBrands: ['13b58e06-8266-4a5b-8113-2de43aa686e1'], // Europcar
  },
  {
    label: "Search Demand",
    href: "/r/europcar-arama",
    icon: Search,
    subItems: null,
    marketerVisible: true,
    brandingVisible: true,
    restrictedBrands: ['13b58e06-8266-4a5b-8113-2de43aa686e1'], // Europcar
  },
  {
    label: "Checkout Tagging Audit",
    href: "/r/europcar-checkout-denetimi",
    icon: ClipboardCheck,
    subItems: null,
    marketerVisible: true,
    brandingVisible: true,
    restrictedBrands: ['13b58e06-8266-4a5b-8113-2de43aa686e1'], // Europcar
  },
  {
    label: "dataLayer Specification",
    href: "/r/europcar-datalayer",
    icon: FileCode,
    subItems: null,
    marketerVisible: true,
    brandingVisible: true,
    restrictedBrands: ['13b58e06-8266-4a5b-8113-2de43aa686e1'], // Europcar
  },
  {
    label: "Blog Inventory",
    href: "/r/europcar-blog",
    icon: FileText,
    subItems: null,
    marketerVisible: true,
    brandingVisible: true,
    restrictedBrands: ['13b58e06-8266-4a5b-8113-2de43aa686e1'], // Europcar
  },
  {
    label: "Non-Brand Search",
    href: "/r/europcar-nonbrand",
    icon: Search,
    subItems: null,
    marketerVisible: true,
    brandingVisible: true,
    restrictedBrands: ['13b58e06-8266-4a5b-8113-2de43aa686e1'], // Europcar
  },
  {
    label: "Location Pages",
    href: "/r/europcar-lokasyon",
    icon: MapPin,
    subItems: null,
    marketerVisible: true,
    brandingVisible: true,
    restrictedBrands: ['13b58e06-8266-4a5b-8113-2de43aa686e1'], // Europcar
  },
  {
    label: "Programmatic Media Plan",
    href: "/budget/europcar-programatik-2026",
    icon: Target,
    subItems: null,
    marketerVisible: true,
    brandingVisible: true,
    restrictedBrands: ['13b58e06-8266-4a5b-8113-2de43aa686e1'], // Europcar
  },
  {
    label: "CX YoY Report",
    href: "/r/gurgencler-cx-yoy-2026",
    icon: TrendingUp,
    subItems: null,
    restrictedBrands: ['526a6404-f685-44cd-b57f-27d692845b82'], // Gürgençler
  },
  {
    // Kreatif sayfaları tek başlık altında. href yalnız açık/kapalı anahtarı, route değil.
    label: "Creatives",
    href: "/creatives",
    icon: MonitorPlay,
    marketerVisible: true,
    brandingVisible: true,
    yatasMarketerHidden: true,
    subItems: [
      // Meta yaratıcıları + Google metin varlıkları, üstte veriden çıkan bulgular. Marka bağımsız.
      { label: "Creative & Copy Insights", href: "/analytics/creative-insights", marketerVisible: true, brandingVisible: true },
      { label: "Ads Content (Live)", href: "/ads-content", marketerVisible: true, brandingVisible: true },
      { label: "Meta Static Creatives", href: "/meta-static-assets", marketerVisible: true, brandingVisible: true },
      { label: "Carousel Card Performance", href: "/meta-carousel-cards", marketerVisible: true, brandingVisible: true },
    ],
  },

  {
    label: "Change History",
    href: "/ads-change-history",
    icon: History,
    subItems: null,
    marketerVisible: true,
    brandingVisible: true,
    yatasMarketerHidden: true
  }
];

const analyticsLinks = [
  { name: 'Overview', href: '/analytics/overview', icon: BarChart },
  { name: 'Source / Medium', href: '/analytics/source-medium', icon: Globe },
  { name: 'Product Performance', href: '/analytics/product-performance', icon: Package },
  { name: 'Funnel Analysis', href: '/analytics/funnel', icon: Filter },
  { name: 'Accounts', href: '/analytics/accounts', icon: Users }
];


const menuItems = [
  {
    title: 'Overview',
    icon: <LayoutDashboard className="w-5 h-5" />,
    path: '/overview2'
  },
  {
    title: 'Google Analytics',
    icon: <BarChart2 />,
    path: '/analytics',
    submenu: [
      { title: 'Analytics Overview', path: '/analytics/analytics-overview' },
      { title: 'GA4 Overview', path: '/analytics/ga4-overview' },
      { title: 'GA4 Audience', path: '/analytics/ga4-audience' },
      { title: 'New vs Returning Revenue', path: '/analytics/new-vs-returning-revenue' },
      { title: 'Session Engagement', path: '/analytics/session-engagement' },
      { title: 'Hourly Order Analysis', path: '/analytics/hourly-order-analysis' },
      { title: 'Weekday Order Analysis', path: '/analytics/weekday-order-analysis' },
      { title: 'Source/Medium', path: '/analytics/source-medium' },
      { title: 'Traffic Acquisition', path: '/analytics/source-medium-monthly' },
      { title: 'GA + Adjust (Combined)', path: '/analytics/combined-traffic-sources' },
      { title: 'Product Performance', path: '/analytics/product-performance' },
      { title: 'Product Portfolio Analysis', path: '/analytics/product-portfolio-analysis' },
      { title: 'Price Elasticity of Demand', path: '/analytics/price-elasticity-of-demand' },
      { title: 'Funnel', path: '/analytics/funnel' },
      { title: 'Conversion Paths', path: '/analytics/conversion-paths' },
      { title: 'Revenue Forecasting', path: '/analytics/revenue-forecasting' },
    ]
  },
  {
    title: 'Ads Overview',
    icon: <DollarSign className="w-5 h-5" />,
    path: '/ads-overview'
  },
  {
    title: 'Campaigns',
    icon: <Megaphone className="w-5 h-5" />,
    path: '/campaigns'
  },
  {
    title: 'Hourly Performance',
    icon: <Clock className="w-5 h-5" />,
    path: '/hourly-performance',
    restrictedBrands: ['58aab54e-8d8c-499c-b706-86ec9435adaf'] // Sadece bu brand ID'de göster
  },
  {
    title: 'Task Board',
    icon: <Trello className="w-5 h-5" />,
    path: '/taskboard'
  },
  {
    title: 'Settings',
    icon: <Settings className="w-5 h-5" />,
    path: '/settings'
  }
];

function Sidebar({ onHoverChange, variant }) {
  const WUNDER_BRAND_ID = '9e1cb4b4-6a46-44ec-85b5-652665a4bd2b';
  const HIGH5_BRAND_ID = 'b20e13f1-2e3f-4c24-83ce-f2b812bfc3e8';
  const KLAUD_BRAND_ID = 'e3250f9b-7015-4bb9-8ef7-eb860738aaae';
  // Hupalupa platformda iki marka olarak duruyor (Eğlence + Hupalupa); markaya
  // özel sayfalar ikisinde de görünür. App.js'teki allowBrandIds ile aynı liste.
  const HUPALUPA_BRAND_IDS = [
    'cb6bbe2d-a3cd-4322-a4e4-2373d10225a9',
    '9e3c368d-d70d-4ba4-9506-fa0f65b526f7',
  ];
  // Brands that get the "Birleşik Kampanyalar" (unified-campaigns) menu item.
  const UNIFIED_CAMPAIGNS_BRAND_IDS = [HIGH5_BRAND_ID, KLAUD_BRAND_ID];
  const [openMenus, setOpenMenus] = useState([]);
  // Glowy Lens: seçili markanın kayıtlı raporları, menüde tek tek listelenir.
  const [lensReports, setLensReports] = useState([]);
  const [openGoogleAdsMenu, setOpenGoogleAdsMenu] = useState(false);
  const [openMetaAdsMenu, setOpenMetaAdsMenu] = useState(false);
  const [openBuyingBehaviorMenu, setOpenBuyingBehaviorMenu] = useState(false);
  const [openGA4Menu, setOpenGA4Menu] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { logout, selectedBrand, setSelectedBrand, user } = useAuth();
  const [brands, setBrands] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  // Hover niyeti: fare kenardan geçip giderken açılıp kapanmasın.
  const hoverTimer = useRef(null);
  const hoverEnter = useCallback(() => {
    clearTimeout(hoverTimer.current);
    hoverTimer.current = setTimeout(() => setIsHovered(true), 80);
  }, []);
  const hoverLeave = useCallback(() => {
    clearTimeout(hoverTimer.current);
    hoverTimer.current = setTimeout(() => setIsHovered(false), 120);
  }, []);
  useEffect(() => () => clearTimeout(hoverTimer.current), []);
  const [connections, setConnections] = useState({
    bigquery: false,
    ikas: false,
    shopify: false,
    woo: false,
    adjust: false,
    criteo: false,
    rtbHouse: false,
    pinterest: false,
    tiktok: false,
  });
  const hasBigQueryConnected = connections.bigquery;
  const hasIkasConnected = connections.ikas;
  const hasShopifyConnected = connections.shopify;
  const hasWooConnected = connections.woo;
  const hasAdjustConnected = connections.adjust;
  const hasCriteoConnected = connections.criteo;
  const hasRtbHouseConnected = connections.rtbHouse;
  const hasPinterestConnected = connections.pinterest;
  const hasTiktokConnected = connections.tiktok;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(true);
      } else {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await fetch('https://api.glowytics.com/api/brands', {
          credentials: 'include'
        });

        if (!response.ok) {
          throw new Error('Failed to fetch brands');
        }

        const data = await response.json();
        setBrands(data.brands || []);
      } catch (error) {
        console.error('Fetch brands error:', error);
      }
    };

    fetchBrands();
  }, []);


  useEffect(() => {
    if (onHoverChange) {
      onHoverChange(isHovered);
    }
    
    // Sidebar kapandığında dropdown'ı da kapat
    if (!isHovered) {
      setIsDropdownOpen(false);
    }
  }, [isHovered, onHoverChange]);

  // Load connection status to conditionally show IKAS item
  useEffect(() => {
    const loadConnections = async () => {
      try {
        const brandId = selectedBrand?.id || localStorage.getItem('currentBrandId');
        if (!brandId) return;
        // Force all connections visible for demo brand
        const demoBrandId = 'ec9873c2-0edb-44eb-ac6f-2670c8e56dc4';
        if (brandId === demoBrandId) {
          setConnections({ bigquery: true, ikas: true, shopify: true, woo: true, adjust: true, criteo: true, rtbHouse: true, pinterest: true, tiktok: true });
          return;
        }
        const res = await fetch('https://api.glowytics.com/api/auth/connections', {
          credentials: 'include',
          headers: { 'X-Brand-ID': brandId }
        });
        if (!res.ok) return;
        const data = await res.json();
        const isActive = (platform) => String(platform || '').toUpperCase() === 'ACTIVE';
        let newConnections = { bigquery: false, ikas: false, shopify: false, woo: false, adjust: false, criteo: false, rtbHouse: false, pinterest: false, tiktok: false };
        if (Array.isArray(data)) {
          const byPlatform = (p) => !!data.find(c => String(c.platform || '').toUpperCase() === p && isActive(c.status));
          newConnections = {
            bigquery: byPlatform('BIGQUERY'),
            ikas: byPlatform('IKAS'),
            shopify: byPlatform('SHOPIFY'),
            woo: byPlatform('WOOCOMMERCE'),
            adjust: byPlatform('ADJUST'),
            criteo: byPlatform('CRITEO_ADS'),
            rtbHouse: byPlatform('RTB_HOUSE'),
            pinterest: byPlatform('PINTEREST_ADS'),
            tiktok: byPlatform('TIKTOK_ADS'),
          };
        } else if (data && typeof data === 'object') {
          const getStatus = (key1, key2) => {
            const obj = data[key1] || data[key2];
            return !!(obj && isActive(obj.status));
          };
          newConnections = {
            bigquery: getStatus('BIGQUERY', 'bigquery'),
            ikas: getStatus('IKAS', 'ikas'),
            shopify: getStatus('SHOPIFY', 'shopify'),
            woo: getStatus('WOOCOMMERCE', 'woocommerce'),
            adjust: getStatus('ADJUST', 'adjust'),
            criteo: getStatus('CRITEO_ADS', 'criteo_ads'),
            rtbHouse: getStatus('RTB_HOUSE', 'rtb_house'),
            pinterest: getStatus('PINTEREST_ADS', 'pinterest_ads'),
            tiktok: getStatus('TIKTOK_ADS', 'tiktok_ads'),
          };
        }
        setConnections(newConnections);
      } catch (e) {
        // ignore
      }
    };
    loadConnections();
  }, [selectedBrand?.id]);

  // (Removed) Auto-open behavior to avoid forcing sections open

  const toggleMenu = useCallback((href) => {
    setOpenMenus(prev =>
      prev.includes(href)
        ? prev.filter(item => item !== href)
        : [...prev, href]
    );
  }, []);

  const toggleGoogleAdsMenu = useCallback(() => {
    setOpenGoogleAdsMenu(prev => !prev);
  }, []);

  const toggleMetaAdsMenu = useCallback(() => {
    setOpenMetaAdsMenu(prev => !prev);
  }, []);

  const toggleBuyingBehaviorMenu = useCallback(() => {
    setOpenBuyingBehaviorMenu(prev => !prev);
  }, []);

  const toggleGA4Menu = useCallback(() => {
    setOpenGA4Menu(prev => !prev);
  }, []);

  const isMenuActive = useCallback((href) => {
    return location.pathname.startsWith(href);
  }, [location.pathname]);

  const handleLogout = useCallback(async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  }, [logout]);

  const handleBrandSelect = useCallback(async (brand) => {
    try {
      await setSelectedBrand(brand);
      localStorage.setItem('selectedBrand', JSON.stringify(brand));
      localStorage.setItem('currentBrandId', brand.id);
      setIsDropdownOpen(false);

      // Sayfayı yenile
      window.location.reload();

    } catch (error) {
      console.error('Error selecting brand:', error);
    }
  }, [setSelectedBrand]);

  const isPathActive = useCallback((path) => {
    return location.pathname === path;
  }, [location.pathname]);


  // Glowy Lens raporları: marka değişince çek; Lens sayfası ekle/sil/yeniden adlandırmada
  // 'glowy-lens:reports' olayıyla güncel listeyi gönderiyor.
  const lensEnabled = navItems.some(it => it.href === '/custom-reports'
    && epostaIzinli(it.restrictedEmails, user?.email));
  useEffect(() => {
    setLensReports([]);
    if (!lensEnabled || !selectedBrand?.id) return;
    let alive = true;
    lensApi.list(selectedBrand.id)
      .then((d) => { if (alive) setLensReports(d.reports || []); })
      .catch(() => {});
    return () => { alive = false; };
  }, [lensEnabled, selectedBrand?.id]);
  useEffect(() => {
    const onReports = (e) => {
      if (e.detail?.brandId === selectedBrand?.id) setLensReports(e.detail.reports || []);
    };
    window.addEventListener('glowy-lens:reports', onReports);
    return () => window.removeEventListener('glowy-lens:reports', onReports);
  }, [selectedBrand?.id]);

  // Add IKAS, SHOPIFY and WOOCOMMERCE as top-level items BETWEEN Search Console and GlowyAI when connected
  const computedNavItems = useMemo(() => {
    const items = [];
    const alreadyHasIkas = navItems.some(it => it.label === 'Ikas');
    const alreadyHasShopify = navItems.some(it => it.label === 'Shopify');
    const alreadyHasWoo = navItems.some(it => it.label === 'WooCommerce');
    navItems.forEach((item) => {
      // GA + Adjust (Combined) sadece Adjust bağlantısı olan brand'lerde görünsün
      let processedItem = item;
      if (item.href === '/custom-reports' && lensReports.length) {
        processedItem = {
          ...item,
          subItems: lensReports.map(r => ({ label: r.name, href: `/custom-reports/${r.id}` })),
        };
      }
      if (item.subItems && Array.isArray(item.subItems)) {
        processedItem = {
          ...item,
          subItems: item.subItems.filter((sub) => {
            if (sub.label === 'GA + Adjust (Combined)' && !hasAdjustConnected) {
              return false;
            }
            if ((sub.label === 'BigQuery Analytics' || sub.label === 'Product Sales (BQ)') && !hasBigQueryConnected) {
              return false;
            }
            if (typeof sub.visibleFor === 'function' && !sub.visibleFor(selectedBrand?.id, user?.email)) {
              return false;
            }
            if (Array.isArray(sub.allowUserIds) && sub.allowUserIds.length > 0) {
              const userId = user?.id || user?.userId || user?._id;
              return !!userId && sub.allowUserIds.includes(userId);
            }
            if (Array.isArray(sub.allowBrandIds) && sub.allowBrandIds.length > 0) {
              return !!selectedBrand?.id && sub.allowBrandIds.includes(selectedBrand.id);
            }
            // Yataş grubu sadeleştirmesi (Esra, 12 Eki 2026): marka marketer'ları görmesin
            if (sub.yatasMarketerHidden && selectedBrand?.currentUserRole === 'MARKETER' && YATAS_REPORT_BRANDS.includes(selectedBrand?.id)) {
              return false;
            }
            // ownerAdminOnly: hide from non-OWNER/ADMIN roles
            if (sub.ownerAdminOnly && !['OWNER', 'ADMIN'].includes(selectedBrand?.currentUserRole)) {
              return false;
            }
            // MARKETER: TikTok Ads + Pinterest altında sadece "Creative Performance" göster
            // (Overview / Campaign Type vb. gizlensin).
            if (selectedBrand?.currentUserRole === 'MARKETER' && (item.label === 'TikTok Ads' || item.label === 'Pinterest')) {
              return sub.label === 'Creative Performance';
            }
            // MARKETER: Meta Ads / Google Ads / Google Analytics altında sadece marketerVisible: true olan sub-item'ları göster
            if (selectedBrand?.currentUserRole === 'MARKETER' && (item.label === 'Meta Ads' || item.label === 'Google Ads' || item.label === 'Google Analytics')) {
              return !!sub.marketerVisible;
            }
            // MARKETER: Raporlar / Growth Intelligence altında marketerVisible: false olanları gizle
            if (selectedBrand?.currentUserRole === 'MARKETER' && (item.label === 'Raporlar' || item.label === 'Growth Intelligence')) {
              return sub.marketerVisible !== false;
            }
            // BRANDING role filter — only sub-items with brandingVisible: true
            if (selectedBrand?.currentUserRole === 'BRANDING') {
              return !!sub.brandingVisible;
            }
            return true;
          })
        };
      }
      // Hide Adjust unless connected
      if (processedItem.label === 'Adjust' && !hasAdjustConnected) {
        return;
      }
      // Hide Criteo unless connected
      if (processedItem.label === 'Criteo' && !hasCriteoConnected) {
        return;
      }
      // Hide RTB House unless connected
      if (processedItem.label === 'RTB House' && !hasRtbHouseConnected) {
        return;
      }
      // Hide Pinterest unless connected
      if (processedItem.label === 'Pinterest' && !hasPinterestConnected) {
        return;
      }
      // Hide TikTok Ads unless connected
      if (processedItem.label === 'TikTok Ads' && !hasTiktokConnected) {
        return;
      }
      items.push(processedItem);
      if (
        processedItem.label === 'Search Console' &&
        hasIkasConnected &&
        !alreadyHasIkas
      ) {
        const ikasSubItems = [
          { label: 'Overview', href: '/ikas/overview' },
          { label: 'Product Performance', href: '/ikas/product-performance' },
          { label: 'Inventory', href: '/ikas/inventory' },
          { label: 'Stock & Cost', href: '/ikas/stock' },
          { label: 'Stock Coverage', href: '/ikas/stock-coverage' },
          ...(selectedBrand?.id === WUNDER_BRAND_ID
            ? [{ label: 'Stock Coverage + GPM', href: '/ikas/monthly-fetch' }]
            : []),
          { label: 'Customer Segments', href: '/ikas/custom-segments' },
          {
            label: 'Buying Behavior',
            subItems: [
              { label: 'Brand Purchase Behavior', href: '/ikas/buying-segment' },
              { label: 'Category Segments', href: '/ikas/category-segments' },
              { label: 'Product Segments', href: '/ikas/product-customer-segments' }
            ]
          },
          { label: 'Loyalty', href: '/ikas/loyalty' }
        ];

        items.push({
          label: 'ikas',
          href: '/ikas/overview',
          icon: 'IkasIcon',
          subItems: ikasSubItems
        });
      }
      if (
        item.label === 'Search Console' &&
        hasShopifyConnected &&
        !alreadyHasShopify
      ) {
        items.push({
          label: 'Shopify',
          href: '/shopify/overview',
          icon: 'ShopifyIcon',
          subItems: [
            { label: 'Overview', href: '/shopify/overview' },
            { label: 'Product Performance', href: '/shopify/product-performance' },
            { label: 'Stock Coverage', href: '/shopify/stock-coverage' },
            { label: 'Customer Segments', href: '/shopify/custom-segments' },
            {
              label: 'Buying Behavior',
              subItems: [
                { label: 'Brand Purchase Behavior', href: '/shopify/buying-segment' },
                { label: 'Category Segments', href: '/shopify/category-segments' },
                { label: 'Product Segments', href: '/shopify/product-customer-segments' }
              ]
            },
            { label: 'Loyalty', href: '/shopify/loyalty' }
          ]
        });
      }
      if (
        item.label === 'Search Console' &&
        hasWooConnected &&
        !alreadyHasWoo
      ) {
        items.push({
          label: 'WooCommerce',
          href: '/woocommerce/overview',
          icon: 'WooIcon',
          subItems: [
            { label: 'Overview', href: '/woocommerce/overview' },
            { label: 'Product Performance', href: '/woocommerce/product-performance' },
            { label: 'Customer Segments', href: '/woocommerce/custom-segments' },
            {
              label: 'Buying Behavior',
              subItems: [
                { label: 'Purchase Segments', href: '/woocommerce/buying-segment' },
                { label: 'Category Segments', href: '/woocommerce/category-segments' },
                { label: 'Product Segments', href: '/woocommerce/product-customer-segments' }
              ]
            },
            { label: 'Loyalty', href: '/woocommerce/loyalty' }
          ]
        });
      }
    });
    if (UNIFIED_CAMPAIGNS_BRAND_IDS.includes(selectedBrand?.id)) {
      items.push({
        label: "Birleşik Kampanyalar",
        href: "/ads-platforms/unified-campaigns",
        marketerVisible: true,
        icon: "AdsplatformIcon",
        iconSrc: "/marketingicon.svg",
      });
    }
    // Marka bazlı günlük + anlık ciro/harcama. Tek ürün markası odaklı (High5'te
    // ASICS, HUPALUPA Store'da NeeDoh) ve üç mecrayı birleştirdiği için Merchant
    // Center değil, kampanya tarafında.
    // 🔑 HUPALUPA Eğlence bilerek DIŞARIDA: e-ticareti yok, GA4'ünde ürün markası
    // taşıyan satış hiç yok — sayfa orada boş açılır.
    if (selectedBrand?.id === HIGH5_BRAND_ID
        || selectedBrand?.id === 'cb6bbe2d-a3cd-4322-a4e4-2373d10225a9') {
      items.push({
        label: "Marka Canlı Takip",
        // 🔑 High5'inki `/high5/marka-canli` olarak KALIYOR — o adres patrona
        // verildi (Efe, 7 Eyl 2026), değiştirmek kafa karıştırır. HUPALUPA
        // panelinde ise markasız yol veriliyor.
        href: selectedBrand?.id === HIGH5_BRAND_ID ? "/high5/marka-canli" : "/marka-canli",
        marketerVisible: true,
        icon: "AdsplatformIcon",
        iconSrc: "/marketingicon.svg",
      });
    }
    // High5: dün ne sattık / hangi kanal / hangi ürün (yalnız High5).
    if (selectedBrand?.id === HIGH5_BRAND_ID) {
      items.push({
        label: "Yesterday",
        href: "/high5/yesterday",
        marketerVisible: true,
        icon: "AdsplatformIcon",
        iconSrc: "/marketingicon.svg",
      });
    }
    // Google Haritalar lokasyon + yorum röntgeni — rapor Hupalupa'ya özel.
    if (HUPALUPA_BRAND_IDS.includes(selectedBrand?.id)) {
      items.push({
        label: "Lokasyon Röntgeni",
        href: "/reports/hupalupa-lokasyon",
        marketerVisible: true,
        icon: "AdsplatformIcon",
        iconSrc: "/marketingicon.svg",
      });
    }
    // Website + pazaryeri satışları (mağazanın sales-by-channel CSV'si) — yalnız HUPALUPA Store.
    if (selectedBrand?.id === 'cb6bbe2d-a3cd-4322-a4e4-2373d10225a9') {
      items.push({
        label: "Kanal Bazlı Satışlar",
        href: "/r/hupalupa-kanal-satislari",
        marketerVisible: true,
        icon: "AdsplatformIcon",
        iconSrc: "/marketingicon.svg",
      });
    }
    // ERP net satış Excel yükleme — veriyi sadece High5 gönderiyor.
    if (selectedBrand?.id === HIGH5_BRAND_ID) {
      items.push({
        label: "Net Satış Yükleme",
        href: "/high5/net-sales",
        marketerVisible: true,
        icon: "AdsplatformIcon",
        iconSrc: "/marketingicon.svg",
      });
    }
    return items;
  }, [hasBigQueryConnected, hasAdjustConnected, hasCriteoConnected, hasRtbHouseConnected, hasPinterestConnected, hasTiktokConnected, hasIkasConnected, hasShopifyConnected, hasWooConnected, selectedBrand, user, lensReports]);

  // Alt öğenin kendi ikonu yoksa bağlı olduğu ana başlığın ikonu kullanılır
  // (Meta Ads altındakiler Meta logosu vb.) — sidebar'da ikonsuz satır kalmasın.
  const PARENT_ICON_SRC = {
    ikas: '/ikaslogoicon.png',
    'Google Ads': '/google_ads-512.webp',
    'Meta Ads': '/6033716.png',
    'TikTok Ads': '/tik-tokiconss.png',
    Shopify: '/shopify_glyph.svg',
    WooCommerce: '/woocommerceicon.png',
    Adjust: '/adjustlogopng.png',
    AdsplatformIcon: '/marketingicon.svg',
    AnalyticsIcon: '/GA4logoicon.svg',
    MarketInsightsIcon: '/insight.svg',
    CommerceIcon: '/shoppingcommercecenter.svg',
    GlowyAIIcon: '/ai.svg',
    GrowthIntelligenceIcon: '/growth.svg',
    SearchConsoleIcon: '/search-console-icon-2025-1v33.svg',
  };
  const parentIcon = (item, cls = 'w-5 h-5') => {
    const src = item.iconSrc || PARENT_ICON_SRC[item.label]
      || (typeof item.icon === 'string' ? PARENT_ICON_SRC[item.icon] : null);
    if (src) return <img src={src} alt="" className={`${cls} shrink-0 object-contain`} />;
    if (item.icon === 'SocialIntelligenceIcon') return <Share2 className={`${cls} shrink-0 text-gray-500`} />;
    if (item.icon === 'BigQueryIcon') return <Database className={`${cls} shrink-0 text-blue-400`} />;
    if (item.icon && typeof item.icon !== 'string') {
      const I = item.icon;
      return <I className={`${cls} shrink-0 text-gray-500`} />;
    }
    return null;
  };
  const withIcon = (icon, label) => (icon ? (
    <div className="flex items-center gap-2">{icon}<span>{label}</span></div>
  ) : label);

  // Ana menü öğesi çizimi; ana listede ve OnSite grubunun altındaki araçlar bölümünde ortak.
  const renderNavItem = (item) => {
    if (item.onsite) return null; // aşağıda kendi grubunda
    if (item.hideForDemo && selectedBrand?.id === 'ec9873c2-0edb-44eb-ac6f-2670c8e56dc4') {
      return null;
    }
    // Restricted brands kontrolü - sadece belirtilen brand ID'lerde göster
    if (item.restrictedBrands && !item.restrictedBrands.includes(selectedBrand?.id)) {
      return null;
    }
    // Restricted emails kontrolü - sadece belirtilen email'lere göster
    if (!epostaIzinli(item.restrictedEmails, user?.email)) {
      return null;
    }
    // MARKETER role filter - marketer users can only see items with marketerVisible: true
    if (selectedBrand?.currentUserRole === 'MARKETER' && (!item.marketerVisible
      || (item.yatasMarketerHidden && YATAS_REPORT_BRANDS.includes(selectedBrand?.id)))) {
      return null;
    }
    // BRANDING role filter — only items with brandingVisible: true
    if (selectedBrand?.currentUserRole === 'BRANDING' && !item.brandingVisible) {
      return null;
    }
    const pathActiveInSubtree = (subs) => {
      if (!subs || !Array.isArray(subs)) return false;
      return subs.some(si => {
        if (si.href && location.pathname.startsWith(si.href)) return true;
        if (si.subItems) return pathActiveInSubtree(si.subItems);
        return false;
      });
    };
    const isActive = item.subItems && Array.isArray(item.subItems) && item.subItems.length
      ? pathActiveInSubtree(item.subItems)
      : isMenuActive(item.href);
    const isOpen = openMenus.includes(item.href);
    const Icon = item.icon;

    return (
      <li key={item.href || item.label}>
        {item.comingSoon ? (
          // Coming Soon ana menü itemları
          <div
            className={`
              flex items-center transition-colors duration-200 rounded-xl
              justify-between px-3.5 py-2 overflow-hidden
              cursor-not-allowed opacity-60
            `}
          >
            <div className="flex items-center min-w-[20px] overflow-hidden [&>img]:shrink-0 [&>svg]:shrink-0">
              {item.iconSrc ? (
                <img
                  src={item.iconSrc}
                  alt={item.label}
                  className="w-5 h-5 flex-shrink-0 object-contain opacity-60"
                />
              ) : item.label === 'Market Insights' ? (
                <img 
                  src="/insight.svg" 
                  alt="Market Insights" 
                  className="w-5 h-5 flex-shrink-0 opacity-60"
                />
              ) : item.icon === "AdsplatformIcon" ? (
                <img 
                  src="/marketingicon.svg" 
                  alt="Ads Platform" 
                  className="w-5 h-5 flex-shrink-0 opacity-60"
                />
              ) : item.icon === "AnalyticsIcon" ? (
                <img 
                  src="/GA4logoicon.svg" 
                  alt="Analytics" 
                  className="w-5 h-5 flex-shrink-0 opacity-60"
                />
              ) : item.icon === "GlowyAIIcon" ? (
                <img
                  src="/ai.svg"
                  alt="GlowyAI"
                  className="w-5 h-5 flex-shrink-0 opacity-60"
                />
              ) : item.icon === "BigQueryIcon" ? (
                <Database className="w-5 h-5 flex-shrink-0 text-blue-400 opacity-60" />
              ) : (
                <Icon className="w-5 h-5 flex-shrink-0 text-gray-400" />
              )}
              <span className={`text-sm text-gray-400 transition-opacity duration-200 whitespace-nowrap shrink-0 ml-2 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>{item.label}</span>
            </div>
            <div className={`flex items-center gap-1 px-2 py-0.5 bg-orange-100 text-orange-600 rounded-full text-xs shrink-0 transition-opacity duration-200 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>
              <Clock className="w-3 h-3" />
              <span>Soon</span>
            </div>
          </div>
        ) : item.subItems ? (
          // Subitem olan menü elemanları
          <button
            onClick={() => isHovered && toggleMenu(item.href)}
            className={`
              flex items-center transition-colors duration-200 rounded-xl
              w-full px-3.5 py-2 justify-between overflow-hidden
              ${isActive 
                ? 'text-blue-600 bg-blue-50 font-medium' 
                : 'text-gray-600 hover:bg-gray-50'}
            `}
          >
            <div className="flex items-center min-w-[20px] overflow-hidden [&>img]:shrink-0 [&>svg]:shrink-0">
              {item.iconSrc ? (
                <img
                  src={item.iconSrc}
                  alt={item.label}
                  className="w-5 h-5 flex-shrink-0 object-contain"
                />
              ) : item.label === 'ikas' ? (
                <img 
                  src="/ikaslogoicon.png" 
                  alt="Ikas" 
                  className="w-5 h-5 flex-shrink-0 rounded-md"
                />
              ) : item.label === 'Google Ads' ? (
                <img 
                  src="/google_ads-512.webp" 
                  alt="Google Ads" 
                  className="w-5 h-5 flex-shrink-0 rounded-sm"
                />
              ) : item.label === 'Meta Ads' ? (
                <img
                  src="/6033716.png"
                  alt="Meta Ads"
                  className="w-5 h-5 flex-shrink-0 rounded-sm"
                />
              ) : item.label === 'TikTok Ads' ? (
                <img
                  src="/tik-tokiconss.png"
                  alt="TikTok Ads"
                  className="w-5 h-5 flex-shrink-0 rounded-sm"
                />
              ) : item.label === 'Shopify' ? (
                <img 
                  src="/shopify_glyph.svg" 
                  alt="Shopify" 
                  className="w-5 h-5 flex-shrink-0"
                />
              ) : item.label === 'WooCommerce' ? (
                <img 
                  src="/woocommerceicon.png" 
                  alt="WooCommerce" 
                  className="w-5 h-5 flex-shrink-0"
                />
              ) : item.label === 'Adjust' ? (
                <img 
                  src="/adjustlogopng.png" 
                  alt="Adjust" 
                  className="w-5 h-5 flex-shrink-0"
                />
              ) : item.icon === "AdsplatformIcon" ? (
                <img 
                  src="/marketingicon.svg" 
                  alt="Ads Platform" 
                  className="w-5 h-5 flex-shrink-0"
                />
              ) : item.icon === "AnalyticsIcon" ? (
                <img 
                  src="/GA4logoicon.svg" 
                  alt="Analytics" 
                  className="w-5 h-5 flex-shrink-0"
                />
              ) : item.icon === "MarketInsightsIcon" ? (
                <img
                  src="/insight.svg"
                  alt="Market Insights"
                  className="w-5 h-5 flex-shrink-0"
                />
              ) : item.icon === "SocialIntelligenceIcon" ? (
                <Share2 className="w-5 h-5 flex-shrink-0" />
              ) : item.icon === "CommerceIcon" ? (
                <img 
                  src="/shoppingcommercecenter.svg" 
                  alt="Commerce Center" 
                  className="w-5 h-5 flex-shrink-0"
                />
              ) : item.icon === "GlowyAIIcon" ? (
                <img
                  src="/ai.svg"
                  alt="GlowyAI"
                  className="w-5 h-5 flex-shrink-0"
                />
              ) : item.icon === "GrowthIntelligenceIcon" ? (
                <img 
                  src="/growth.svg" 
                  alt="Growth Intelligence" 
                  className="w-5 h-5 flex-shrink-0"
                />
              ) : item.icon === "SearchConsoleIcon" ? (
                <img 
                  src="/search-console-icon-2025-1v33.svg" 
                  alt="Search Console" 
                  className="w-5 h-5 flex-shrink-0"
                />
              ) : item.icon === "BigQueryIcon" ? (
                <Database className="w-5 h-5 flex-shrink-0 text-blue-400" />
              ) : (
                <Icon className="w-5 h-5 flex-shrink-0" />
              )}
              <span className={`text-sm transition-opacity duration-200 whitespace-nowrap shrink-0 ml-2 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>{item.label}</span>
            </div>
            <ChevronDown className={`w-4 h-4 transition-[transform,opacity] duration-200 ml-auto shrink-0 ${isOpen ? 'rotate-180' : ''} ${isHovered ? 'opacity-100' : 'opacity-0'}`} />
          </button>
        ) : (
          // Link tipi menü elemanları
          <Link
            to={item.href}
            className={`
              flex items-center transition-colors duration-200 rounded-xl
              px-3.5 py-2 justify-start overflow-hidden
              ${isActive 
                ? 'text-blue-600 bg-blue-50 font-medium' 
                : 'text-gray-600 hover:bg-gray-50'}
            `}
          >
            {(item.iconSrc) ? (
              <img
                src={item.iconSrc}
                alt={item.label}
                className="w-5 h-5 flex-shrink-0 object-contain"
              />
            ) : (item.label === 'ikas') ? (
              <img 
                src="/ikaslogoicon.png" 
                alt="Ikas" 
                className="w-5 h-5 flex-shrink-0 rounded-md"
              />
            ) : (item.label === 'Shopify') ? (
              <img 
                src="/shopify_glyph.svg" 
                alt="Shopify" 
                className="w-5 h-5 flex-shrink-0"
              />
            ) : (item.label === 'WooCommerce') ? (
              <img 
                src="/woocommerceicon.png" 
                alt="WooCommerce" 
                className="w-5 h-5 flex-shrink-0"
              />
            ) : (item.label === 'Adjust') ? (
              <img 
                src="/adjustlogopng.png" 
                alt="Adjust" 
                className="w-5 h-5 flex-shrink-0"
              />
            ) : item.icon === "AdsplatformIcon" ? (
              <img 
                src="/marketingicon.svg" 
                alt="Ads Platform" 
                className="w-5 h-5 flex-shrink-0"
              />
            ) : item.icon === "AnalyticsIcon" ? (
              <img 
                src="/GA4logoicon.svg" 
                alt="Analytics" 
                className="w-5 h-5 flex-shrink-0"
              />
            ) : item.icon === "CommerceIcon" ? (
              <img 
                src="/shoppingcommercecenter.svg" 
                alt="Commerce Center" 
                className="w-5 h-5 flex-shrink-0"
              />
            ) : item.icon === "SearchConsoleIcon" ? (
              <img 
                src="/search-console-icon-2025-1v33.svg" 
                alt="Search Console" 
                className="w-5 h-5 flex-shrink-0"
              />
            ) : item.icon === "TrelloSvgIcon" ? (
              <img 
                src="/trello.svg" 
                alt="Task Board" 
                className="w-5 h-5 flex-shrink-0"
              />
            ) : item.icon === "GlowyAIIcon" ? (
              <img
                src="/ai.svg"
                alt="GlowyAI"
                className="w-5 h-5 flex-shrink-0"
              />
            ) : item.icon === "BigQueryIcon" ? (
              <Database className="w-5 h-5 flex-shrink-0 text-blue-400" />
            ) : (
              <Icon className="w-5 h-5 flex-shrink-0" />
            )}
            <span className={`text-sm transition-opacity duration-200 whitespace-nowrap shrink-0 ml-2 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>{item.label}</span>
          </Link>
        )}

        {/* Submenüleri göster, sadece hover ve menü açıkken */}
        {isOpen && item.subItems && (
          // Kapanırken anında silinmez: yükseklik + opaklık geçişiyle toplanır.
          <div className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isHovered ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
          <div className="min-h-0 overflow-hidden">
          {/* Sabit genişlik: panel daralırken yazılar alt satıra kayıp listeyi oynatmasın */}
          <div className="mt-1 ml-4 pl-3 border-l border-gray-100 w-[224px]">
            {item.subItems.map((subItem) => (
              <div key={subItem.href || subItem.label}>
                {/* Top-level Google Ads submenu with icons */}
                {item.label === "Google Ads" ? (
                  <Link
                    key={subItem.href}
                    to={subItem.href}
                    className={`
                      flex items-center px-3 py-2 text-sm rounded-lg my-0.5
                      ${location.pathname === subItem.href
                        ? 'text-blue-600 bg-blue-50 font-medium'
                        : 'text-gray-500 hover:bg-gray-50'
                      }
                    `}
                  >
                    {(() => {
                      const getGoogleAdsIcon = (label) => {
                        switch (label) {
                          case 'Overview':
                            return '/google_ads-512.webp';
                          case 'Search':
                            return '/search.svg';
                          case 'Display':
                            return '/display.svg';
                          case 'Demand Gen':
                            return '/demandgen.svg';
                          case 'GDN Creatives':
                            return '/display.svg';
                          case 'Shopping':
                            return '/shopping.svg';
                          case 'Performance Max':
                            return '/performancemax.svg';
                          case 'Dynamic Search':
                            return '/search.svg';
                          case 'Video':
                            return '/youtube.svg';
                          case 'App':
                            return '/app.svg';
                          default:
                            return '/google_ads-512.webp'; // eşlemesi olmayan alt öğe Google Ads logosunu alır
                        }
                      };
                      const iconSrc = getGoogleAdsIcon(subItem.label);
                      return iconSrc ? (
                        <div className="flex items-center gap-2">
                          <img src={iconSrc} alt={subItem.label} className="w-5 h-5" />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (
                        subItem.label
                      );
                    })()}
                  </Link>
                ) : null}
                {subItem.groupHeader ? (
                  // Link değil, alt menü içi grup başlığı
                  <div className="px-3 pt-3 pb-1 text-[10px] font-semibold uppercase tracking-wider text-gray-400 first:pt-1">
                    {subItem.label}
                  </div>
                ) : subItem.label === "Google Ads" ? (
                  // Google Ads submenü
                  <>
                    <button
                      onClick={toggleGoogleAdsMenu}
                      className={`
                        w-full flex items-center justify-between px-3 py-2 text-sm rounded-lg my-0.5
                        ${location.pathname.includes('/ads-platforms/google-ads')
                          ? 'text-blue-600 bg-blue-50 font-medium'
                          : 'text-gray-600 hover:bg-gray-50'
                        }
                      `}
                    >
                      <div className="flex items-center gap-2">
                        <img 
                          src="/google_ads-512.webp" 
                          alt="Google Ads" 
                          className="w-5 h-5 rounded-sm"
                        />
                        <span>{subItem.label}</span>
                      </div>
                      <ChevronRight className={`w-4 h-4 transition-transform duration-200 
                        ${openGoogleAdsMenu ? 'rotate-90' : ''}`} 
                      />
                    </button>
                    
                    {/* Google Ads SubItems */}
                    {openGoogleAdsMenu && subItem.subItems && (
                      <div className="mt-1 ml-4 pl-3 border-l border-gray-100">
                        {subItem.subItems.map((nestedItem) => {
                          const getGoogleAdsIcon = (label) => {
                            switch (label) {
                              case 'Search':
                                return '/search.svg';
                              case 'Display':
                                return '/display.svg';
                              case 'Demand Gen':
                                return '/demandgen.svg';
                              case 'Shopping':
                                return '/shopping.svg';
                              case 'Performance Max':
                                return '/performancemax.svg';
                              case 'Video':
                                return '/youtube.svg';
                              case 'App':
                                return '/app.svg';
                              case 'Dynamic Search':
                                return '/search.svg';
                              default:
                                return '/google_ads-512.webp';
                            }
                          };

                          const iconSrc = getGoogleAdsIcon(nestedItem.label);

                          return (
                            <Link
                              key={nestedItem.href}
                              to={nestedItem.href}
                              className={`
                                flex items-center px-3 py-2 text-sm rounded-lg my-0.5
                                ${location.pathname === nestedItem.href
                                  ? 'text-blue-600 bg-blue-50 font-medium'
                                  : 'text-gray-500 hover:bg-gray-50'
                                }
                              `}
                            >
                              {iconSrc ? (
                                <div className="flex items-center gap-2">
                                  <img 
                                    src={iconSrc} 
                                    alt={nestedItem.label} 
                                    className="w-5 h-5"
                                  />
                                  <span>{nestedItem.label}</span>
                                </div>
                              ) : (
                                nestedItem.label
                              )}
                            </Link>
                          );
                        })}
                      </div>
                    )}
                  </>
                ) : subItem.label === "Meta Ads" ? (
                  // Meta Ads submenü
                  <>
                    <button
                      onClick={toggleMetaAdsMenu}
                      className={`
                        w-full flex items-center justify-between px-3 py-2 text-sm rounded-lg my-0.5
                        ${location.pathname.includes('/ads-platforms/meta-overview')
                          ? 'text-blue-600 bg-blue-50 font-medium'
                          : 'text-gray-600 hover:bg-gray-50'
                        }
                      `}
                    >
                      <div className="flex items-center gap-2">
                        <img 
                          src="/6033716.png" 
                          alt="Meta Ads" 
                          className="w-5 h-5 rounded-sm"
                        />
                        <span>{subItem.label}</span>
                      </div>
                      <ChevronRight className={`w-4 h-4 transition-transform duration-200 
                        ${openMetaAdsMenu ? 'rotate-90' : ''}`} 
                      />
                    </button>
                    
                    {/* Meta Ads SubItems */}
                    {openMetaAdsMenu && subItem.subItems && (
                      <div className="mt-1 ml-4 pl-3 border-l border-gray-100">
                        {subItem.subItems.map((nestedItem) => (
                          <Link
                            key={nestedItem.href}
                            to={nestedItem.href}
                            className={`
                              flex items-center px-3 py-2 text-sm rounded-lg my-0.5
                              ${location.pathname === nestedItem.href
                                ? 'text-blue-600 bg-blue-50 font-medium'
                                : 'text-gray-500 hover:bg-gray-50'
                              }
                            `}
                          >
                            <div className="flex items-center gap-2">
                              <img 
                                src="/6033716.png" 
                                alt={nestedItem.label} 
                                className="w-5 h-5 flex-shrink-0"
                              />
                              <span>{nestedItem.label}</span>
                            </div>
                          </Link>
                        ))}
                      </div>
                    )}
                  </>
                ) : subItem.label === "GA4" ? (
                  <>
                    <button
                      onClick={toggleGA4Menu}
                      className={`
                        w-full flex items-center justify-between px-3 py-2 text-sm rounded-lg my-0.5
                        ${(() => {
                          const kids = (subItem.subItems || []).map(k => k.href).filter(Boolean);
                          const active = kids.some(h => location.pathname.startsWith(h));
                          return active ? 'text-blue-600 bg-blue-50 font-medium' : 'text-gray-600 hover:bg-gray-50';
                        })()}
                      `}
                    >
                      <div className="flex items-center gap-2">
                        <img 
                          src="/GA4logoicon.svg" 
                          alt="GA4" 
                          className="w-5 h-5 flex-shrink-0"
                        />
                        <span>{subItem.label}</span>
                      </div>
                      <ChevronRight className={`w-4 h-4 transition-transform duration-200 
                        ${openGA4Menu ? 'rotate-90' : ''}`} 
                      />
                    </button>
                    {openGA4Menu && subItem.subItems && (
                      <div className="mt-1 ml-4 pl-3 border-l border-gray-100">
                        {subItem.subItems.map((nestedItem) => (
                          <Link
                            key={nestedItem.href}
                            to={nestedItem.href}
                            className={`
                              block px-3 py-2 text-sm rounded-lg my-0.5
                              ${location.pathname === nestedItem.href
                                ? 'text-blue-600 bg-blue-50 font-medium'
                                : 'text-gray-500 hover:bg-gray-50'
                              }
                            `}
                          >
                            {nestedItem.label}
                          </Link>
                        ))}
                      </div>
                    )}
                  </>
                ) : subItem.label === "Buying Behavior" ? (
                  <>
                    <button
                      onClick={toggleBuyingBehaviorMenu}
                      className={`
                        w-full flex items-center justify-between px-3 py-2 text-sm rounded-lg my-0.5
                        ${(() => {
                          const kids = (subItem.subItems || []).map(k => k.href).filter(Boolean);
                          const active = kids.some(h => location.pathname.startsWith(h));
                          return active ? 'text-blue-600 bg-blue-50 font-medium' : 'text-gray-600 hover:bg-gray-50';
                        })()}
                      `}
                    >
                      <div className="flex items-center gap-2">
                        <img 
                      src={
                        item.label === 'WooCommerce'
                          ? '/woocommerceicon.png'
                          : item.label === 'Shopify'
                          ? '/shopify_glyph.svg'
                          : '/ikaslogoicon.png'
                      } 
                          alt="Customer Buying Behavior" 
                          className="w-5 h-5 rounded-md"
                        />
                        <span>{subItem.label}</span>
                      </div>
                      <ChevronRight className={`w-4 h-4 transition-transform duration-200 
                        ${openBuyingBehaviorMenu ? 'rotate-90' : ''}`} 
                      />
                    </button>
                    {openBuyingBehaviorMenu && subItem.subItems && (
                      <div className="mt-1 ml-4 pl-3 border-l border-gray-100">
                        {subItem.subItems.map((nestedItem) => (
                          <Link
                            key={nestedItem.href}
                            to={nestedItem.href}
                            className={`
                              block px-3 py-2 text-sm rounded-lg my-0.5
                              ${location.pathname === nestedItem.href
                                ? 'text-blue-600 bg-blue-50 font-medium'
                                : 'text-gray-500 hover:bg-gray-50'
                              }
                            `}
                          >
                            {withIcon(parentIcon(item), nestedItem.label)}
                          </Link>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  // Diğer normal submenu linkleri
                  subItem.comingSoon ? (
                    // Coming Soon items - tıklanabilir değil
                    <div
                      className="flex items-center justify-between px-3 py-2 text-sm rounded-lg my-0.5 cursor-not-allowed opacity-60"
                    >
                      {subItem.label === 'Merchant Insights' ? (
                        <div className="flex items-center gap-2 text-gray-400">
                          <img src="/shopping-cart.svg" alt="Merchant Insights" className="w-4 h-4" />
                          <span>{subItem.label}</span>
                        </div>
                      ) : subItem.label === 'YouTube Radar' ? (
                        <div className="flex items-center gap-2 text-gray-400">
                          <img src="/youtube.svg" alt="YouTube Radar" className="w-5 h-5" />
                          <span>{subItem.label}</span>
                        </div>
                      ) : subItem.label === 'Instagram Radar' ? (
                        <div className="flex items-center gap-2 text-gray-400">
                          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                          <span>{subItem.label}</span>
                        </div>
                      ) : subItem.label === 'YouTube Trends' ? (
                        <div className="flex items-center gap-2 text-gray-400">
                          <img src="/trend.svg" alt="YouTube Trends" className="w-5 h-5" />
                          <span>{subItem.label}</span>
                        </div>
                      ) : subItem.label === 'Keyword Discover' ? (
                        <div className="flex items-center gap-2 text-gray-400">
                          <img src="/discover.svg" alt="Keyword Discover" className="w-5 h-5" />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (
                      <span className="text-gray-400">{subItem.label}</span>
                      )}
                      <div className="flex items-center gap-1 px-2 py-0.5 bg-orange-100 text-orange-600 rounded-full text-xs">
                        <Clock className="w-3 h-3" />
                        <span>Soon</span>
                      </div>
                    </div>
                  ) : (
                    // Normal tıklanabilir linkler (Google Ads üst seviyesinde ikonlu satırlar zaten render edildiği için tekrar etme)
                    item.label === 'Google Ads' ? null : (
                    <Link
                      to={subItem.href}
                      className={`
                        flex items-center px-3 py-2 text-sm rounded-lg my-0.5
                        ${location.pathname === subItem.href
                          ? 'text-blue-600 bg-blue-50 font-medium'
                          : 'text-gray-600 hover:bg-gray-50'
                        }
                      `}
                    >
                    {item.label === 'Google Analytics' ? (
                      <div className="flex items-center gap-2">
                        <img
                          src="/GA4logoicon.svg"
                          alt="GA4"
                          className="w-5 h-5"
                        />
                        <span>{subItem.label}</span>
                      </div>
                    ) : subItem.icon === 'calendar' ? (
                      <div className="flex items-center gap-2">
                        <CalendarDays className="w-4 h-4 text-gray-500" />
                        <span>{subItem.label}</span>
                      </div>
                    ) : (item.label === 'ikas') ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/ikaslogoicon.png" 
                            alt="Ikas" 
                            className="w-5 h-5 rounded-md"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (item.label === 'Shopify') ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/shopify_glyph.svg" 
                            alt="Shopify" 
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (item.label === 'WooCommerce') ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/woocommerceicon.png" 
                            alt="WooCommerce" 
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (item.label === 'Adjust') ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/adjustlogopng.png" 
                            alt="Adjust" 
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Merchant Insights') ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/shopping-cart.svg" 
                            alt="Merchant Insights" 
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Google Merchant Center') ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/google-merchant-centerpngg.svg" 
                            alt="Google Merchant Center" 
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Merchant Center Inventory') ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/google-merchant-centerpngg.svg" 
                            alt="Merchant Center Inventory" 
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Variant Performance') ? (
                        <div className="flex items-center gap-2">
                          <img
                            src="/google-merchant-centerpngg.svg"
                            alt="Variant Performance"
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Custom Labels & BCG') ? (
                        <div className="flex items-center gap-2">
                          <img
                            src="/google-merchant-centerpngg.svg"
                            alt="Custom Labels & BCG"
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Search Console') ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/search-console-icon-2025-1v33.svg" 
                            alt="Search Console" 
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : ((subItem.label === 'Overview' && (item.label === 'Search Console')) || subItem.label === 'Monthly Queries' || subItem.label === 'Blog SEO') ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/search-console-icon-2025-1v33.svg" 
                            alt={subItem.label} 
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'YouTube Radar') ? (
                        <div className="flex items-center gap-2">
                          <img
                            src="/youtube.svg"
                            alt="YouTube Radar"
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Instagram Radar') ? (
                        <div className="flex items-center gap-2">
                          <img src="/instagram.png" alt="Instagram Radar" className="w-5 h-5" />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'TikTok Radar') ? (
                        <div className="flex items-center gap-2">
                          <img src="/tik-tokiconss.png" alt="TikTok Radar" className="w-5 h-5" />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'YouTube Trends') ? (
                        <div className="flex items-center gap-2">
                          <img
                            src="/trend.svg"
                            alt="YouTube Trends"
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Price Comparison') ? (
                        <div className="flex items-center gap-2">
                          <img
                            src="/trend.svg"
                            alt="Price Comparison"
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Marketing Holiday Planner') ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/calendar.svg" 
                            alt="Marketing Holiday Planner" 
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Google Trends') ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/searchtrend.svg" 
                            alt="Google Trends" 
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Search Volume') ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/analyzing.svg" 
                            alt="Search Volume" 
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Keyword Discover') ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/discoverkeyword.svg" 
                            alt="Keyword Discover" 
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Category Seasonality') ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/star.svg" 
                            alt="Category Seasonality" 
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Facebook Ads Library') ? (
                        <div className="flex items-center gap-2">
                          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#1877F2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === 'Google Ads Transparency') ? (
                        <div className="flex items-center gap-2">
                          <img src="/googleiconpng.png" alt="Google" className="w-5 h-5" />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (subItem.label === "GA4 Overview" ||
                        subItem.label === "Traffic Acquisition" ||
                        subItem.label === "Product Performance" ||
                        subItem.label === "Funnel Analysis" ||
                        subItem.label === "Product Portfolio Analysis" ||
                        subItem.label === "Price Elasticity of Demand" || 
                        subItem.label === "Revenue Forecasting" ||
                        subItem.label === "On‑site search") ? (
                        <div className="flex items-center gap-2">
                          <img 
                            src="/GA4logoicon.svg" 
                            alt="GA4" 
                            className="w-5 h-5"
                          />
                          <span>{subItem.label}</span>
                        </div>
                      ) : subItem.icon ? (
                        <div className="flex items-center gap-2">
                          <img src={subItem.icon} alt={subItem.label} className="w-5 h-5 object-contain" />
                          <span>{subItem.label}</span>
                        </div>
                      ) : (
                        withIcon(parentIcon(item), subItem.label)
                      )}
                    </Link>
                    )
                  )
                )}
              </div>
            ))}
          </div>
          </div>
          </div>
        )}
      </li>
    );
  };

  return (
    <>
      {/* Mobile Header */}
      <div className="md:hidden fixed top-0 left-0 right-0 h-16 bg-white border-b border-gray-100 flex items-center px-4 z-40">
        <button 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="p-2 rounded-xl hover:bg-gray-50 transition-colors"
        >
          {isMobileMenuOpen ? <ChevronLeft size={22} /> : <Menu size={22} />}
        </button>
        
        <div className="flex-1 flex justify-center">
          <img
            src="/Calisma-Yuzeyi-20@5x-4.png"
            alt="Glowytics Logo"
            className="h-8"
          />
        </div>
      </div>

      {/* Mobile Backdrop */}
      {isMobileMenuOpen && (
        <div 
          className="md:hidden fixed inset-0 bg-black/20 backdrop-blur-sm z-30"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Sidebar - Mouse Hover Efekti Eklenmiş Hali */}
      <div
        className={`
          fixed top-0 left-0 h-screen bg-white border-r border-gray-200 z-40
          ${variant === 'gray' ? 'sb-gray' : ''}
          transition-[width,transform,box-shadow] duration-200 ease-out flex flex-col
          ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
          ${isHovered ? 'md:w-64 md:shadow-2xl md:shadow-slate-900/10' : 'md:w-16'}
        `}
        style={{ willChange: 'width' }}
        onMouseEnter={hoverEnter}
        onMouseLeave={hoverLeave}
      >
        {/* Logo: "G" ikonu hep aynı yerde (merkez 32px) durur; yazılı logo aynı G ile
            üstüne biner ve sadece solar — kapanırken logo kaymaz, iki G üst üste binmez. */}
        <div className="relative flex-shrink-0 hidden md:flex items-center h-16 px-[18px] border-b border-gray-100 overflow-hidden">
          <img src="/logoicon.png" alt="Glowytics" className="h-7 w-7 shrink-0" />
          <img
            src="/Calisma-Yuzeyi-20@5x-4.png"
            alt=""
            className={`absolute left-[18px] h-7 max-w-none bg-white transition-opacity duration-200 ${isHovered ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
          />
        </div>

        {/* Kapalıyken yerinde bina ikonu olarak kalır; yükseklik değişmez → liste zıplamaz. */}
        <div className="relative px-2 py-4 border-b border-gray-100">
            <button
              onClick={() => isHovered && setIsDropdownOpen(!isDropdownOpen)}
              title={isHovered ? undefined : selectedBrand?.name}
              className="w-full flex items-center justify-between px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-xl transition-colors overflow-hidden"
            >
              <div className="flex items-center gap-2 min-w-0">
                <Building className="w-4 h-4 shrink-0 text-gray-500" />
                <span className={`font-medium text-gray-700 truncate text-sm transition-opacity duration-200 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>
                  {selectedBrand?.name || 'Select Brand'}
                </span>
              </div>
              <ChevronDown className={`w-4 h-4 shrink-0 text-gray-500 transition-[transform,opacity] duration-200 
                ${isDropdownOpen ? 'rotate-180' : ''} ${isHovered ? 'opacity-100' : 'opacity-0'}`} 
              />
            </button>

            {/* Dropdown Menu */}
            {isDropdownOpen && (
              <div className="absolute left-3 right-3 mt-2 py-2 bg-white rounded-xl shadow-lg border border-gray-100 z-50 flex flex-col">
                <div className="max-h-72 overflow-y-auto pr-1">
                  {brands.map((brand) => (
                    <button
                      key={brand.id}
                      onClick={() => handleBrandSelect(brand)}
                      className={`w-full text-left px-4 py-2 hover:bg-gray-50 transition-colors
                        ${selectedBrand?.id === brand.id ? 'bg-blue-50 text-blue-600' : 'text-gray-700'}`}
                    >
                      <div className="flex items-center gap-3">
                        <Building className={`w-4 h-4 ${
                          selectedBrand?.id === brand.id ? 'text-blue-500' : 'text-gray-400'
                        }`} />
                        <span className="truncate">{brand.name}</span>
                      </div>
                    </button>
                  ))}
                </div>
                
                {/* Brand Selector Link (fixed) */}
                <div className="border-t border-gray-100 mt-2 pt-2 sticky bottom-0 bg-white">
                  <Link
                    to="/brand-selector"
                    className="w-full text-left px-4 py-2 text-blue-600 hover:bg-blue-50 transition-colors flex items-center gap-2"
                  >
                    <Plus className="w-4 h-4" />
                    <span>Manage Brands</span>
                  </Link>
                </div>
              </div>
            )}
        </div>

        {/* Navigation */}
        <nav className={`
          flex-1 overflow-y-auto py-6 sidebar-scroll
          overflow-x-hidden
          ${!isMobileMenuOpen ? '' : 'md:pt-6 pt-20'}
        `}>
          <ul className="space-y-2 px-2">
            {/* Overview Link - Icon Only or Full Text (hidden for BRANDING role; Yataş MARKETER'da da gizli → Performans Panosu) */}
            {selectedBrand?.currentUserRole !== 'BRANDING' && !(YATAS_REPORT_BRANDS.includes(selectedBrand?.id) && !YATAS_OVERVIEW_EMAILS.includes(String(user?.email || '').toLowerCase())) && (
              <li>
                <Link
                  to="/overview2"
                  className={`
                    flex items-center transition-colors duration-200 rounded-xl
                    px-3.5 py-2 justify-start overflow-hidden
                    ${isPathActive('/overview2')
                      ? 'text-blue-600 bg-blue-50 font-medium'
                      : 'text-gray-600 hover:bg-gray-50'}
                  `}
                >
                  <img src="/layout.svg" alt="Overview" className="w-5 h-5 flex-shrink-0" />
                  <span className={`text-sm transition-opacity duration-200 whitespace-nowrap shrink-0 ml-2 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>Overview</span>
                </Link>
              </li>
            )}

            {/* Yataş grubu: Overview'un altında kendi panosu (eski Overview aynen kalır) */}
            {YATAS_REPORT_BRANDS.includes(selectedBrand?.id) && (
              <li>
                <Link
                  to="/yatas/pano"
                  className={`
                    flex items-center transition-colors duration-200 rounded-xl
                    px-3.5 py-2 justify-start overflow-hidden
                    ${isPathActive('/yatas/pano')
                      ? 'text-blue-600 bg-blue-50 font-medium'
                      : 'text-gray-600 hover:bg-gray-50'}
                  `}
                >
                  <Gauge className="w-5 h-5 flex-shrink-0" />
                  <span className={`text-sm transition-opacity duration-200 whitespace-nowrap shrink-0 ml-2 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>Performans Panosu</span>
                </Link>
              </li>
            )}
            {YATAS_REPORT_BRANDS.includes(selectedBrand?.id) && (
              <li>
                <Link
                  to="/yatas/bulten"
                  className={`
                    flex items-center transition-colors duration-200 rounded-xl
                    px-3.5 py-2 justify-start overflow-hidden
                    ${isPathActive('/yatas/bulten')
                      ? 'text-blue-600 bg-blue-50 font-medium'
                      : 'text-gray-600 hover:bg-gray-50'}
                  `}
                >
                  <Newspaper className="w-5 h-5 flex-shrink-0" />
                  <span className={`text-sm transition-opacity duration-200 whitespace-nowrap shrink-0 ml-2 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>Aylık Bülten</span>
                </Link>
              </li>
            )}

            {/* Diğer Navigation Items */}
            {(YATAS_REPORT_BRANDS.includes(selectedBrand?.id)
              ? [...YATAS_MENU_FIRST.map((l) => computedNavItems.find((it) => it.label === l)).filter(Boolean),
                ...computedNavItems.filter((it) => !YATAS_MENU_FIRST.includes(it.label))]
              : computedNavItems).filter((it) => !it.afterOnsite).map(renderNavItem)}

            {/* Glowy OnSite (Widgets + Glowy Desk): en altta, mor zeminli ayrı grup + Beta etiketi */}
            {(() => {
              const onsiteItems = computedNavItems.filter((it) => it.onsite
                && (!it.restrictedBrands || it.restrictedBrands.includes(selectedBrand?.id))
                && epostaIzinli(it.restrictedEmails, user?.email));
              if (!onsiteItems.length) return null;
              return (
                <li className="pt-3 mt-3 border-t border-gray-100">
                  <div className={`rounded-2xl bg-gradient-to-b from-violet-50 to-fuchsia-50 ring-1 ring-violet-100 p-1.5 overflow-hidden`}>
                    {/* Başlık: açıkta "Glowy OnSite · BETA", kapalıda ortada küçük "BETA" — ikisi yerinde solar */}
                    <div className="relative h-6">
                      <div className={`absolute inset-x-0 top-0 flex items-center justify-between px-2 pt-1 whitespace-nowrap transition-opacity duration-200 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>
                        <span className="text-[11px] font-semibold uppercase tracking-wide text-violet-700">Glowy OnSite</span>
                        <span className="px-1.5 py-0.5 rounded-full bg-violet-600 text-white text-[10px] font-semibold leading-none">BETA</span>
                      </div>
                      <div className={`absolute left-0 top-1 w-9 text-center text-[9px] font-bold tracking-wide text-violet-600 transition-opacity duration-200 ${isHovered ? 'opacity-0' : 'opacity-100'}`}>BETA</div>
                    </div>
                    {onsiteItems.map((item) => {
                      const Icon = item.icon;
                      const active = isMenuActive(item.href);
                      return (
                        <Link
                          key={item.href}
                          to={item.href}
                          title={isHovered ? undefined : item.label}
                          className={`flex items-center rounded-xl transition-colors duration-200
                            px-2 py-2 justify-start overflow-hidden
                            ${active ? 'bg-white text-violet-700 font-medium shadow-sm' : 'text-violet-900/70 hover:bg-white/70 hover:text-violet-800'}`}
                        >
                          <Icon className={`w-5 h-5 flex-shrink-0 ${active ? 'text-violet-600' : 'text-violet-500'}`} />
                          <span className={`text-sm transition-opacity duration-200 whitespace-nowrap shrink-0 ml-2 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>{item.label}</span>
                        </Link>
                      );
                    })}
                  </div>
                </li>
              );
            })()}

            {/* Glowy araçları (Studio, Lens, Mail): OnSite grubunun altında */}
            {(() => {
              // renderNavItem yetkisi olmayan öğe için null döner; boş grup çizilmesin.
              const tools = computedNavItems.filter((it) => it.afterOnsite).map(renderNavItem).filter(Boolean);
              return tools.length ? (
                <li className="pt-3 mt-3 border-t border-gray-100"><ul className="space-y-2">{tools}</ul></li>
              ) : null;
            })()}
          </ul>
        </nav>

        {/* Alt menü: nav satırlarıyla aynı düzen (ikon merkezi 32px), etiket solar */}
        <div className="flex-shrink-0 border-t border-gray-100 bg-white px-2 py-2 space-y-0.5">
          {selectedBrand?.currentUserRole !== 'MARKETER' && selectedBrand?.id !== 'ec9873c2-0edb-44eb-ac6f-2670c8e56dc4' && (
            <Link
              to="/settings"
              className="flex items-center px-4 py-2 rounded-lg overflow-hidden text-gray-400 hover:text-gray-600 hover:bg-gray-50"
            >
              <Settings className="w-4 h-4 shrink-0" />
              <span className={`ml-2.5 text-sm truncate transition-opacity duration-200 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>Settings</span>
            </Link>
          )}
          <Link
            to="/my-account"
            className="flex items-center px-4 py-2 rounded-lg overflow-hidden text-gray-400 hover:text-gray-600 hover:bg-gray-50"
          >
            <Users className="w-4 h-4 shrink-0" />
            <span className={`ml-2.5 text-sm truncate transition-opacity duration-200 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>My account</span>
          </Link>
          <button
            onClick={handleLogout}
            className="w-full flex items-center px-4 py-2 rounded-lg overflow-hidden text-gray-400 hover:text-red-600 hover:bg-red-50"
          >
            <LogOut className="w-4 h-4 shrink-0" />
            <span className={`ml-2.5 text-sm truncate transition-opacity duration-200 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>Log out</span>
          </button>
        </div>
      </div>
    </>
  );
}

export default Sidebar;   